export default {
  status: 'success',
  data: {
    stats: {
      total: 10076,
      offset: 0,
      limit: 50,
      order: 'desc',
      base: 'USD',
      totalMarkets: 54482,
      totalExchanges: 297,
      totalMarketCap: 192869047719.05563,
      total24hVolume: 46667967944.59647,
    },
    base: { symbol: 'USD', sign: '$' },
    coins: [
      {
        id: 1,
        uuid: 'Qwsogvtv82FCd',
        slug: 'bitcoin-btc',
        symbol: 'BTC',
        name: 'Bitcoin',
        description:
          'Bitcoin is the first decentralized digital currency that can be sent through the internet globally without using financial institutions like banks. The network is controlled by many of its users, instead of a few entities.',
        color: '#f7931A',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/yUKVK8exb/1-btc-egg.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://bitcoin.org',
        socials: [
          {
            name: 'r/bitcoin',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/bitcoin/',
            type: 'reddit',
          },
          {
            name: 'bitcoin/bitcoin',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/bitcoin/bitcoin',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'bitcoin.org',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://bitcoin.org',
          },
          {
            name: 'r/bitcoin',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/bitcoin/',
            type: 'reddit',
          },
          {
            name: 'bitcoin/bitcoin',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/bitcoin/bitcoin',
            type: 'github',
          },
          {
            name: 'blockchain.com',
            url: 'http://web.archive.org/web/20200411222841/https://www.blockchain.com/explorer',
            type: 'explorer',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 17643,
        numberOfExchanges: 278,
        type: 'coin',
        volume: 24765773422,
        marketCap: 125293282440,
        price: '6839.5823121966',
        circulatingSupply: 18318850,
        totalSupply: 18318850,
        approvedSupply: true,
        firstSeen: 1330214400000,
        change: -0.89,
        rank: 1,
        history: [
          '6900.7234596003',
          '6878.4228167489',
          '6865.8155190562',
          '6880.0800460624',
          '6903.0052302611',
          '6904.522432078',
          '6907.1086865007',
          '6922.3358770495',
          '6914.6209549103',
          '6922.9894301596',
          '6883.4601436085',
          '6883.0879027375',
          '6863.3051381404',
          '6854.2508827198',
          '6863.5620184265',
          '6870.8714089306',
          '6861.9531305696',
          '6832.2862556775',
          '6827.9976265871',
          '6838.633991065',
          '6804.1970608303',
          '6800.2193407141',
          '6804.8292141029',
          '6791.8867936174',
          '6788.3771470482',
          '6824.6854355868',
          '6839.5823121966',
        ],
        allTimeHigh: { price: '19500.47124838819', timestamp: 1513555200000 },
        penalty: false,
      },
      {
        id: 2,
        uuid: 'razxDUgYGNAdQ',
        slug: 'ethereum-eth',
        symbol: 'ETH',
        name: 'Ethereum',
        description:
          'Ethereum is a public decentralized blockchain that provides peer-to-peer smart contracts, without the interference of third parties. This open source (transparent) platform hosts and distributes decentralized applications, thus connecting peers directly.',
        color: '#3C3C3D',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/rk4RKHOuW/eth.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://www.ethereum.org',
        socials: [
          {
            name: 'ethereum',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/ethereum',
            type: 'twitter',
          },
          {
            name: 'ethereum',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/ethereum/',
            type: 'reddit',
          },
          {
            name: 'ethtrader',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/ethtrader/',
            type: 'reddit',
          },
          {
            name: 'BitcoinTalk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=428589.0',
            type: 'bitcointalk',
          },
          {
            name: 'YouTube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/UCNOfzGXD_C9YMYmnefmPH0g',
            type: 'youtube',
          },
          {
            name: 'ethereumproject',
            url: 'http://web.archive.org/web/20200411222841/https://facebook.com/ethereumproject',
            type: 'facebook',
          },
          {
            name: 'ethereum',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/ethereum',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'ethereum',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/ethereum',
            type: 'twitter',
          },
          {
            name: 'ethereum',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/ethereum/',
            type: 'reddit',
          },
          {
            name: 'ethtrader',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/ethtrader/',
            type: 'reddit',
          },
          {
            name: 'BitcoinTalk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=428589.0',
            type: 'bitcointalk',
          },
          {
            name: 'YouTube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/UCNOfzGXD_C9YMYmnefmPH0g',
            type: 'youtube',
          },
          {
            name: 'ethereumproject',
            url: 'http://web.archive.org/web/20200411222841/https://facebook.com/ethereumproject',
            type: 'facebook',
          },
          {
            name: 'ethereum',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/ethereum',
            type: 'github',
          },
          {
            name: 'www.ethereum.org',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://www.ethereum.org',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 12892,
        numberOfExchanges: 270,
        type: 'coin',
        volume: 10037690474,
        marketCap: 17269532836,
        price: '157.1717075323',
        circulatingSupply: 109876854.47185043,
        totalSupply: 110479015.37400001,
        approvedSupply: true,
        firstSeen: 1438905600000,
        change: -1.37,
        rank: 2,
        history: [
          '159.3507278063',
          '158.5190909147',
          '158.0506177218',
          '159.0706573211',
          '159.7845589368',
          '159.8686398866',
          '160.0323725596',
          '160.6467457547',
          '160.3136123232',
          '160.5345729554',
          '158.9467109174',
          '158.9155475483',
          '158.2002102985',
          '157.7450086117',
          '158.3905800035',
          '158.8002688573',
          '158.2677212794',
          '157.5367241892',
          '157.3100950668',
          '157.6625985753',
          '156.0934396761',
          '156.0872020177',
          '156.3373166457',
          '155.4250294817',
          '154.9006122288',
          '156.1576007647',
          '157.1717075323',
        ],
        allTimeHigh: { price: '1353.5489580569788', timestamp: 1515888000000 },
        penalty: false,
      },
      {
        id: 3,
        uuid: '-l8Mn2pVlRs-p',
        slug: 'xrp-xrp',
        symbol: 'XRP',
        name: 'XRP',
        description:
          'Ripple is a global real-time settlement network that connects banks around the world, allowing immediate cross-border transactions using less intermediaries. The cross-border transfers occur within seconds between banks globally, whilst providing both parties an end-to-end visibility throughout the transactions.',
        color: '#000000',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/B1oPuTyfX/xrp.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://ripple.com',
        socials: [
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/ripplepay',
            type: 'facebook',
          },
          {
            name: 'ripple',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/ripple',
            type: 'twitter',
          },
          {
            name: 'ripplevideo1',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/user/ripplevideo1',
            type: 'youtube',
          },
          {
            name: 'r/ripple',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/ripple/',
            type: 'reddit',
          },
          {
            name: 'interledger/five-bells-demo',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/interledger/five-bells-demo',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/ripplepay',
            type: 'facebook',
          },
          {
            name: 'ripple',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/ripple',
            type: 'twitter',
          },
          {
            name: 'ripplevideo1',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/user/ripplevideo1',
            type: 'youtube',
          },
          {
            name: 'r/ripple',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/ripple/',
            type: 'reddit',
          },
          {
            name: 'interledger/five-bells-demo',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/interledger/five-bells-demo',
            type: 'github',
          },
          {
            name: 'ripple.com',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://ripple.com',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 712,
        numberOfExchanges: 164,
        type: 'coin',
        volume: 1522006691,
        marketCap: 8218312675,
        price: '0.1870533382',
        circulatingSupply: 43935664307,
        totalSupply: 99991020177,
        approvedSupply: true,
        firstSeen: 1421798400000,
        change: -1.04,
        rank: 3,
        history: [
          '0.1890246565',
          '0.1884292079',
          '0.1876146359',
          '0.1880911195',
          '0.1892473931',
          '0.1903772835',
          '0.1910109324',
          '0.1914513422',
          '0.1912091945',
          '0.1919038703',
          '0.1905172321',
          '0.1907176996',
          '0.1901221379',
          '0.1890381923',
          '0.1893098921',
          '0.1896929087',
          '0.1889132823',
          '0.1875451814',
          '0.1866373887',
          '0.1874958787',
          '0.1864866614',
          '0.1864546992',
          '0.1876462683',
          '0.1866275578',
          '0.1864277729',
          '0.1866736824',
          '0.1870533382',
        ],
        allTimeHigh: { price: '3.1592207876597747', timestamp: 1515369600000 },
        penalty: false,
      },
      {
        id: 8,
        uuid: 'HIVsRcGKkPFtW',
        slug: 'tether-usdt',
        symbol: 'USDT',
        name: 'Tether',
        description:
          'Tether has pegged its USDT tokens to the price of the US dollar by using blockchain technology. The USDT is a so-called stable currency because of its low price volatility.',
        color: '#22a079',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/SJs1nH_OZ/usdt.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://tether.to/',
        socials: [
          {
            name: 'tether_to',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/tether_to',
            type: 'twitter',
          },
          {
            name: 'r/tether',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/tether/',
            type: 'reddit',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/tether.to',
            type: 'facebook',
          },
        ],
        links: [
          {
            name: 'tether.to',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://tether.to/',
          },
          {
            name: 'tether_to',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/tether_to',
            type: 'twitter',
          },
          {
            name: 'r/tether',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/tether/',
            type: 'reddit',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/tether.to',
            type: 'facebook',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 7040,
        numberOfExchanges: 177,
        type: 'coin',
        volume: 32140150765,
        marketCap: 4281252583,
        price: '0.9982127607',
        circulatingSupply: 4288917905,
        totalSupply: 4288917905,
        approvedSupply: true,
        firstSeen: 1420761600000,
        change: -0.05,
        rank: 4,
        history: [
          '0.9987368374',
          '1.001275502',
          '1.0011392545',
          '0.9998350028',
          '1.000213197',
          '1.0000326689',
          '0.9997866645',
          '0.9991751987',
          '0.9985399947',
          '0.9991117113',
          '0.9995085696',
          '0.9991177004',
          '0.9985326093',
          '0.9984696461',
          '0.9993224049',
          '0.9996727004',
          '0.9994818058',
          '0.9994913587',
          '0.9996819085',
          '0.9997461243',
          '0.999573528',
          '0.9998605611',
          '0.999650347',
          '1.0004776223',
          '1.0008687106',
          '0.9991480358',
          '0.9982127607',
        ],
        allTimeHigh: { price: '2.00000000065111', timestamp: 1469145600000 },
        penalty: false,
      },
      {
        id: 4,
        uuid: 'ZlZpzOJo43mIo',
        slug: 'bitcoincash-bch',
        symbol: 'BCH',
        name: 'Bitcoin Cash',
        description:
          'Bitcoin ABC is an electronic cash platform that allows peer-to-peer online cash payments to be made without the clearance of a clearing house. Also, Bitcoin ABC is a continuation of the bitcoin cash blockchain history.',
        color: '#8dc451',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/By8ziihX7/bch.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://www.bitcoincash.org/',
        socials: [
          {
            name: 'bitcolncash',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/bitcolncash',
            type: 'twitter',
          },
          {
            name: 'r/bitcoincash',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/bitcoincash/',
            type: 'reddit',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=2040221.0',
            type: 'bitcointalk',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/bitcoincashorg',
            type: 'facebook',
          },
          {
            name: 'bitcoin-abc',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/Bitcoin-ABC/bitcoin-abc',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'bitcolncash',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/bitcolncash',
            type: 'twitter',
          },
          {
            name: 'r/bitcoincash',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/bitcoincash/',
            type: 'reddit',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=2040221.0',
            type: 'bitcointalk',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/bitcoincashorg',
            type: 'facebook',
          },
          {
            name: 'bitcoin-abc',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/Bitcoin-ABC/bitcoin-abc',
            type: 'github',
          },
          {
            name: 'www.bitcoincash.org',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://www.bitcoincash.org/',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 803,
        numberOfExchanges: 197,
        type: 'coin',
        volume: 2756828686,
        marketCap: 4222808957,
        price: '229.7956230621',
        circulatingSupply: 18376368.09809993,
        totalSupply: 18376520.89679993,
        approvedSupply: true,
        firstSeen: 1541808000000,
        change: -1.95,
        rank: 5,
        history: [
          '234.3578358716',
          '233.3362770923',
          '232.9008825319',
          '233.649638619',
          '234.3573652378',
          '234.8957587117',
          '235.3002414372',
          '237.6595282446',
          '237.8937154343',
          '238.685705354',
          '236.1586045893',
          '236.2365505114',
          '234.9690046856',
          '233.7679487599',
          '233.8608823783',
          '234.2553412078',
          '233.9985538227',
          '232.1315565985',
          '231.9778949619',
          '233.2732702953',
          '229.9931934745',
          '228.7820487543',
          '230.0453837158',
          '226.3990312782',
          '224.9870135063',
          '227.5596940727',
          '229.7956230621',
        ],
        allTimeHigh: { price: '508.54130064281685', timestamp: 1541808000000 },
        penalty: false,
      },
      {
        id: 4875,
        uuid: 'VcMY11NONHSA0',
        slug: 'bitcoinsv-bsv',
        symbol: 'BSV',
        name: 'Bitcoin SV',
        description:
          'Bitcoin SV or Bitcoin Satoshi Vision is fork from Bitcoin Cash and has the aim to create a stable, scalable and secure payment method, by restoring what was the Bitcoin protocol.',
        color: '#eab300',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/388ehh6kq/bitcoin-sv-1.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://bitcoinsv.io/',
        socials: [
          {
            name: 'bitcoinsvnode',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/bitcoinsvnode',
            type: 'twitter',
          },
          {
            name: 'bitcoin-sv/bitcoin-sv',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/bitcoin-sv/bitcoin-sv',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'bitcoinsvnode',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/bitcoinsvnode',
            type: 'twitter',
          },
          {
            name: 'bitcoin-sv/bitcoin-sv',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/bitcoin-sv/bitcoin-sv',
            type: 'github',
          },
          {
            name: 'bitcoinsv.io',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://bitcoinsv.io/',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 271,
        numberOfExchanges: 99,
        type: 'coin',
        volume: 2003204246,
        marketCap: 3430293958,
        price: '186.6700080835',
        circulatingSupply: 18376245.83192325,
        totalSupply: 18376245.83192325,
        approvedSupply: true,
        firstSeen: 1541808000000,
        change: -0.8,
        rank: 6,
        history: [
          '188.1694474712',
          '186.2512740649',
          '185.4304389363',
          '187.1342258669',
          '187.3061668341',
          '187.4344930785',
          '187.7318561279',
          '188.8760059195',
          '188.8349466865',
          '188.3725751213',
          '185.8958865631',
          '186.2386394962',
          '185.5037605413',
          '183.9669221897',
          '184.6575554859',
          '185.0128579614',
          '184.3934708701',
          '182.3257572991',
          '182.3337926151',
          '184.3422736136',
          '182.9070730909',
          '182.8097669831',
          '183.1285155825',
          '182.6002897607',
          '182.5138531022',
          '185.0180231688',
          '186.6700080835',
        ],
        allTimeHigh: { price: '371.24602840278504', timestamp: 1581465600000 },
        penalty: false,
      },
      {
        id: 7,
        uuid: 'D7B1x_ks7WhV5',
        slug: 'litecoin-ltc',
        symbol: 'LTC',
        name: 'Litecoin',
        description:
          'Litecoin is a peer-to-peer decentralized digital currency with an instant, near zero-cost payment service to peers across the world. It features a faster transaction confirmation status, along with a refined storage competency.',
        color: '#345d9d',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/BUvPxmc9o/ltcnew.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://litecoin.org',
        socials: [
          {
            name: 'litecoinproject',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/litecoinproject',
            type: 'twitter',
          },
          {
            name: 'Telegram',
            url: 'http://web.archive.org/web/20200411222841/https://web.telegram.org/#/im?p=@litecoin',
            type: 'telegram',
          },
          {
            name: 'r/litecoin',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/litecoin/',
            type: 'reddit',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=47417.0',
            type: 'bitcointalk',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/uc8unj4yczgc5e7sb_cckdgg',
            type: 'youtube',
          },
          {
            name: 'ltcfoundation',
            url: 'http://web.archive.org/web/20200411222841/http://www.instagram.com/ltcfoundation',
            type: 'instagram',
          },
        ],
        links: [
          {
            name: 'litecoin.org',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://litecoin.org',
          },
          {
            name: 'litecoinproject',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/litecoinproject',
            type: 'twitter',
          },
          {
            name: 'Telegram',
            url: 'http://web.archive.org/web/20200411222841/https://web.telegram.org/#/im?p=@litecoin',
            type: 'telegram',
          },
          {
            name: 'r/litecoin',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/litecoin/',
            type: 'reddit',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=47417.0',
            type: 'bitcointalk',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/uc8unj4yczgc5e7sb_cckdgg',
            type: 'youtube',
          },
          {
            name: 'ltcfoundation',
            url: 'http://web.archive.org/web/20200411222841/http://www.instagram.com/ltcfoundation',
            type: 'instagram',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 2674,
        numberOfExchanges: 232,
        type: 'coin',
        volume: 2228392084,
        marketCap: 2718931482,
        price: '42.1662047608',
        circulatingSupply: 64481294.85010045,
        totalSupply: 64481294.85010045,
        approvedSupply: true,
        firstSeen: 1382572800000,
        change: -0.65,
        rank: 7,
        history: [
          '42.4403615907',
          '42.314672114',
          '42.1932535679',
          '42.352649081',
          '42.5660360311',
          '42.7336429745',
          '42.7658070124',
          '42.9509164244',
          '42.9272744061',
          '42.9243449266',
          '42.5712084922',
          '42.6519066561',
          '42.4716350029',
          '42.4085663805',
          '42.4770694047',
          '42.5275525461',
          '42.4083460588',
          '42.293210758',
          '42.3653378024',
          '42.5052210237',
          '42.0621146133',
          '41.9755369643',
          '42.0505696675',
          '41.8278825709',
          '41.7792680076',
          '42.0265373653',
          '42.1662047608',
        ],
        allTimeHigh: { price: '356.5915738792805', timestamp: 1513728000000 },
        penalty: false,
      },
      {
        id: 5,
        uuid: 'iAzbfXiBBKkR6',
        slug: 'eos-eos',
        symbol: 'EOS',
        name: 'EOS',
        description:
          'EOS is an operating system on the blockchain that runs decentralized applications for businesses. The main focus of the platform is performance and scalability of smart contracts and transaction throughput. EOS is built to be horizontally scalable, so that in the future it can handle thousands of business apps.',
        color: '#443f54',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/PqOYrWSje/eos2.svg',
        websiteUrl: 'http://web.archive.org/web/20200411222841/https://eos.io/',
        socials: [
          {
            name: 'block_one_',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/block_one_',
            type: 'twitter',
          },
          {
            name: 'r/eos',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/eos/',
            type: 'reddit',
          },
          {
            name: 'Discord',
            url: 'http://web.archive.org/web/20200411222841/https://discordapp.com/invite/zbabdrm',
            type: 'discord',
          },
          {
            name: 'eosio',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/eosio',
            type: 'medium',
          },
          {
            name: 'BitcoinTalk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=1904415.0',
            type: 'bitcointalk',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/eosblockchain',
            type: 'facebook',
          },
          {
            name: 'eosio',
            url: 'http://web.archive.org/web/20200411222841/http://github.com/eosio',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'eos.io',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://eos.io/',
          },
          {
            name: 'Staking guide',
            url: 'http://web.archive.org/web/20200411222841/https://www.stakingrewards.com/asset/eos',
            type: 'website',
          },
          {
            name: 'block_one_',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/block_one_',
            type: 'twitter',
          },
          {
            name: 'r/eos',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/eos/',
            type: 'reddit',
          },
          {
            name: 'Discord',
            url: 'http://web.archive.org/web/20200411222841/https://discordapp.com/invite/zbabdrm',
            type: 'discord',
          },
          {
            name: 'eosio',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/eosio',
            type: 'medium',
          },
          {
            name: 'BitcoinTalk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=1904415.0',
            type: 'bitcointalk',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/eosblockchain',
            type: 'facebook',
          },
          {
            name: 'eosio',
            url: 'http://web.archive.org/web/20200411222841/http://github.com/eosio',
            type: 'github',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 571,
        numberOfExchanges: 132,
        type: 'coin',
        volume: 2051199828,
        marketCap: 2270478278,
        price: '2.4892716149',
        circulatingSupply: 912105478.6326002,
        totalSupply: 1018408319.4191,
        approvedSupply: true,
        firstSeen: 1498694400000,
        change: -0.51,
        rank: 8,
        history: [
          '2.5021284962',
          '2.4958393764',
          '2.4942098626',
          '2.5048529242',
          '2.5161291874',
          '2.5220711813',
          '2.5260894289',
          '2.5369412793',
          '2.5329432731',
          '2.5430671195',
          '2.5230472478',
          '2.5240008625',
          '2.5177299346',
          '2.511455961',
          '2.5139057477',
          '2.5151504238',
          '2.510085549',
          '2.4965726291',
          '2.4960222784',
          '2.5059345093',
          '2.4685963533',
          '2.4640690648',
          '2.46976252',
          '2.4542140587',
          '2.4509221864',
          '2.4732745417',
          '2.4892716149',
        ],
        allTimeHigh: { price: '20.618763559581794', timestamp: 1525046400000 },
        penalty: false,
      },
      {
        id: 14,
        uuid: 'WcwrkfNI4FUAe',
        slug: 'binancecoin-bnb',
        symbol: 'BNB',
        name: 'Binance Coin',
        description:
          'Binance Coin is used for trading on the Binance exchange. When using Binance Coin you will receive a discount on the fees you need to pay. Binance aims to create a Decentralized Exchange (DEX) where Binance coin will function as the underlying token. Binance Coin is built on the Ethereum blockchain.',
        color: '#e8b342',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/B1N19L_dZ/bnb.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://www.binance.com/?ref=35424440',
        socials: [],
        links: [
          {
            name: 'www.binance.com',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://www.binance.com/?ref=35424440',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 436,
        numberOfExchanges: 84,
        type: 'coin',
        volume: 345382570,
        marketCap: 1851234490,
        price: '13.7335386057',
        circulatingSupply: 134796613.1094881,
        totalSupply: 140345602,
        approvedSupply: true,
        firstSeen: 1503014400000,
        change: -1.74,
        rank: 9,
        history: [
          '13.9762930729',
          '13.8818824497',
          '13.7311275181',
          '13.7597976276',
          '13.8562726447',
          '13.9395407143',
          '14.0052001278',
          '14.0003773967',
          '14.0184275921',
          '14.0620442016',
          '13.9659039887',
          '13.9625878682',
          '13.9167028157',
          '13.8628427857',
          '13.9017931412',
          '13.9419137318',
          '13.8933746703',
          '13.8204984183',
          '13.8145114642',
          '13.8374530707',
          '13.7239542858',
          '13.6784326878',
          '13.697277129',
          '13.6520852218',
          '13.6533612573',
          '13.705349914',
          '13.7335386057',
        ],
        allTimeHigh: { price: '37.77723478000876', timestamp: 1561161600000 },
        penalty: false,
      },
      {
        id: 71,
        uuid: 'DXwP4wF9ksbBO',
        slug: 'huobitoken-ht',
        symbol: 'HT',
        name: 'Huobi Token',
        description: null,
        color: '#2daadf',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/ryFpQe0c7/ht.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://www.huobi.com/',
        socials: [
          {
            name: 'huobi-global',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/huobi-global',
            type: 'medium',
          },
          {
            name: 'huobi_pro',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/huobi_pro',
            type: 'twitter',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/ucabkgl5rrak61e2qtjtqcxw/featured',
            type: 'youtube',
          },
          {
            name: 'huobiglobalofficial',
            url: 'http://web.archive.org/web/20200411222841/https://www.instagram.com/huobiglobalofficial',
            type: 'instagram',
          },
          {
            name: 'huobiproofficial',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/huobiproofficial',
            type: 'telegram',
          },
        ],
        links: [
          {
            name: 'huobi-global',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/huobi-global',
            type: 'medium',
          },
          {
            name: 'huobi_pro',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/huobi_pro',
            type: 'twitter',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/ucabkgl5rrak61e2qtjtqcxw/featured',
            type: 'youtube',
          },
          {
            name: 'huobiglobalofficial',
            url: 'http://web.archive.org/web/20200411222841/https://www.instagram.com/huobiglobalofficial',
            type: 'instagram',
          },
          {
            name: 'huobiproofficial',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/huobiproofficial',
            type: 'telegram',
          },
          {
            name: 'www.huobi.com',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://www.huobi.com/',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 117,
        numberOfExchanges: 40,
        type: 'coin',
        volume: 153749226,
        marketCap: 1568251056,
        price: '3.7167437897',
        circulatingSupply: 421942201.1,
        totalSupply: 500000000,
        approvedSupply: true,
        firstSeen: 1517702400000,
        change: 1.6,
        rank: 10,
        history: [
          '3.6583895117',
          '3.6559304422',
          '3.6486514481',
          '3.6434601663',
          '3.6538256613',
          '3.6620762682',
          '3.6656913623',
          '3.7015312123',
          '3.6980990097',
          '3.6970106287',
          '3.6763512644',
          '3.6734857294',
          '3.6511495195',
          '3.6424822288',
          '3.6533545677',
          '3.6604739791',
          '3.6525224069',
          '3.6329294235',
          '3.628579965',
          '3.6380936769',
          '3.6193132639',
          '3.6563160332',
          '3.6886882384',
          '3.679538279',
          '3.6780191363',
          '3.6885398387',
          '3.7167437897',
        ],
        allTimeHigh: { price: '5.906084061311888', timestamp: 1528243200000 },
        penalty: false,
      },
      {
        id: 18,
        uuid: 'fsIbGOEJWbzxG',
        slug: 'tezos-xtz',
        symbol: 'XTZ',
        name: 'Tezos',
        description:
          'Tezos is a smart contract platform that uses blockchain voting to be self-governing by its token holders. Also, the platform aims to boost the security of smart contracts through formal verification of code.',
        color: '#2c7df7',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/HkLUdilQ7/xtz.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://www.tezos.com',
        socials: [
          {
            name: 'tezos',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/tezos',
            type: 'twitter',
          },
          {
            name: 'r/tezos',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/tezos/',
            type: 'reddit',
          },
          {
            name: '@tezos',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/@tezos',
            type: 'medium',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=715818.0',
            type: 'bitcointalk',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/ucmexyclrgsifqs_sqmeolqq',
            type: 'youtube',
          },
          {
            name: 'tezos/tezos',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/tezos/tezos',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'tezos.com',
            url: 'http://web.archive.org/web/20200411222841/https://www.tezos.com',
            type: 'website',
          },
          {
            name: 'Staking guide',
            url: 'http://web.archive.org/web/20200411222841/https://www.stakingrewards.com/asset/tezos',
            type: 'website',
          },
          {
            name: 'Earn Tezos',
            url: 'http://web.archive.org/web/20200411222841/https://www.coinbase.com/earn/tezos',
            type: 'website',
          },
          {
            name: 'Rewards Calculator',
            url: 'http://web.archive.org/web/20200411222841/https://stake.fish/tezos/calculator/',
            type: 'website',
          },
          {
            name: 'mytezosbaker.com',
            url: 'http://web.archive.org/web/20200411222841/https://mytezosbaker.com/',
            type: 'website',
          },
          {
            name: 'Baking Cycles Bot',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/tezosalerts',
            type: 'website',
          },
          {
            name: 'tezos',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/tezos',
            type: 'twitter',
          },
          {
            name: 'r/tezos',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/tezos/',
            type: 'reddit',
          },
          {
            name: '@tezos',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/@tezos',
            type: 'medium',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=715818.0',
            type: 'bitcointalk',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/ucmexyclrgsifqs_sqmeolqq',
            type: 'youtube',
          },
          {
            name: 'tezos/tezos',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/tezos/tezos',
            type: 'github',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 109,
        numberOfExchanges: 47,
        type: 'coin',
        volume: 231190285,
        marketCap: 1376346945,
        price: '1.9476668479',
        circulatingSupply: 706664462.063474,
        totalSupply: 831945438.237824,
        approvedSupply: true,
        firstSeen: 1530662400000,
        change: 1.2,
        rank: 11,
        history: [
          '1.9246453304',
          '1.9205826028',
          '1.9101626843',
          '1.9266716113',
          '1.9363798664',
          '1.9607258909',
          '1.9911389827',
          '2.0208976342',
          '2.0143895603',
          '2.0231317149',
          '1.9919747793',
          '1.9932890846',
          '1.9688031865',
          '1.9653033774',
          '1.9748327209',
          '1.9895906398',
          '1.9844784254',
          '1.9597513049',
          '1.9526726853',
          '1.9829881028',
          '1.9582703108',
          '1.9440875965',
          '1.9401934497',
          '1.9142622104',
          '1.9026882229',
          '1.9349847218',
          '1.9476668479',
        ],
        allTimeHigh: { price: '3.645240520528623', timestamp: 1582070400000 },
        penalty: false,
      },
      {
        id: 1524,
        uuid: 'PDKcptVnzJTmN',
        slug: 'okb-okb',
        symbol: 'OKB',
        name: 'OKB',
        description:
          'OKB is a global utility token issued by OK Blockchain Foundation, set to connect prospective digital asset projects to OKEx users as well as professional investors, creating an OKEx ecosystem that helps to advance the development of blockchain technology and the digital asset industry.',
        color: '#2d60e0',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/BJcjC5rCQ/Okex.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://www.okex.com/activity/okbBoss',
        socials: [
          {
            name: 'okex_',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/okex_',
            type: 'twitter',
          },
          {
            name: 'okex_announcements',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/okex_announcements',
            type: 'telegram',
          },
          {
            name: 'okexofficial_en',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/okexofficial_en',
            type: 'telegram',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/1418774981516264',
            type: 'facebook',
          },
        ],
        links: [
          {
            name: 'www.okex.com',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://www.okex.com/activity/okbBoss',
          },
          {
            name: 'okex_',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/okex_',
            type: 'twitter',
          },
          {
            name: 'okex_announcements',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/okex_announcements',
            type: 'telegram',
          },
          {
            name: 'okexofficial_en',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/okexofficial_en',
            type: 'telegram',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/1418774981516264',
            type: 'facebook',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 106,
        numberOfExchanges: 26,
        type: 'coin',
        volume: 114937152,
        marketCap: 1286532182,
        price: '4.5486492574',
        circulatingSupply: 282838290.94,
        totalSupply: 300000000,
        approvedSupply: true,
        firstSeen: 1538524800000,
        change: -1.03,
        rank: 12,
        history: [
          '4.596113447',
          '4.5768168188',
          '4.5500453429',
          '4.5520721258',
          '4.5712292471',
          '4.5649502999',
          '4.5820128468',
          '4.6296648952',
          '4.6479157553',
          '4.6446788049',
          '4.5941523399',
          '4.6013176549',
          '4.5781739388',
          '4.5749870935',
          '4.5814808662',
          '4.5844888741',
          '4.5677551205',
          '4.543846682',
          '4.5499244725',
          '4.5596704896',
          '4.5013730674',
          '4.4901310571',
          '4.4889189608',
          '4.4879703047',
          '4.4998417833',
          '4.5200221196',
          '4.5486492574',
        ],
        allTimeHigh: { price: '7.056194853319747', timestamp: 1582070400000 },
        penalty: false,
      },
      {
        id: 59,
        uuid: 'VLqpJwogdhHNb',
        slug: 'chainlink-link',
        symbol: 'LINK',
        name: 'Chainlink',
        description:
          'ChainLink is aiming to become a fully decentralized oracle network. It functions like a bridge between smart contracts and off-chain applications, to grant acces to off-chain resources like data feeds, web APIs or retail payments for example. ChainLink is built on the Ethereum blockchain. The LINK token is used to pay for off-chain resources demanded by a smart contract.',
        color: '#4680b0',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/9NOP9tOem/chainlink.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://chain.link/',
        socials: [
          {
            name: 'smart_contract',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/smart_contract',
            type: 'twitter',
          },
          {
            name: 'r/chainlink',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/chainlink/',
            type: 'reddit',
          },
        ],
        links: [
          {
            name: 'smart_contract',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/smart_contract',
            type: 'twitter',
          },
          {
            name: 'r/chainlink',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/chainlink/',
            type: 'reddit',
          },
          {
            name: 'chain.link',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://chain.link/',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 186,
        numberOfExchanges: 73,
        type: 'coin',
        volume: 593863413,
        marketCap: 1224983287,
        price: '3.2363338179',
        circulatingSupply: 378509559.3432162,
        totalSupply: 1000000000,
        approvedSupply: true,
        firstSeen: 1505952000000,
        change: -0.23,
        rank: 13,
        history: [
          '3.2438037929',
          '3.2296213823',
          '3.2184758644',
          '3.2192334008',
          '3.2801103176',
          '3.3526187269',
          '3.3262886838',
          '3.3495401978',
          '3.3721148411',
          '3.4113596403',
          '3.357479982',
          '3.3364393366',
          '3.2526078355',
          '3.243247852',
          '3.2654433958',
          '3.2927098617',
          '3.2697146577',
          '3.2322610599',
          '3.2366895245',
          '3.249365478',
          '3.1756406122',
          '3.1604899488',
          '3.1650822532',
          '3.1206010407',
          '3.100952691',
          '3.1791596045',
          '3.2363338179',
        ],
        allTimeHigh: { price: '4.769561888541205', timestamp: 1583366400000 },
        penalty: false,
      },
      {
        id: 9,
        uuid: 'qzawljRxB5bYu',
        slug: 'cardano-ada',
        symbol: 'ADA',
        name: 'Cardano',
        description:
          'Cardano is a blockchain platform that is built in the secure Haskell programming language. The platform features decentralized applications and contracts that operate at low cost in a secure and scalable way.',
        color: '#3cc8c8',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/ryY28nXhW/ada.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://www.cardano.org/en/home/',
        socials: [
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/groups/cardanocommunity',
            type: 'facebook',
          },
          {
            name: 'cardano',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/cardano',
            type: 'twitter',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/ucbq9vgfezru1yri1zdcttgg',
            type: 'youtube',
          },
          {
            name: 'r/cardano',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/cardano/',
            type: 'reddit',
          },
          {
            name: 'input-output-hk/cardano-sl',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/input-output-hk/cardano-sl',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/groups/cardanocommunity',
            type: 'facebook',
          },
          {
            name: 'cardano',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/cardano',
            type: 'twitter',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/ucbq9vgfezru1yri1zdcttgg',
            type: 'youtube',
          },
          {
            name: 'r/cardano',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/cardano/',
            type: 'reddit',
          },
          {
            name: 'input-output-hk/cardano-sl',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/input-output-hk/cardano-sl',
            type: 'github',
          },
          {
            name: 'www.cardano.org',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://www.cardano.org/en/home/',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 149,
        numberOfExchanges: 60,
        type: 'coin',
        volume: 77943106,
        marketCap: 1033675972,
        price: '0.0332238322',
        circulatingSupply: 31112484745,
        totalSupply: 31112484745,
        approvedSupply: true,
        firstSeen: 1506902400000,
        change: -0.25,
        rank: 14,
        history: [
          '0.0333087185',
          '0.0332231285',
          '0.0331819965',
          '0.0333466673',
          '0.0335816254',
          '0.033700779',
          '0.0337572995',
          '0.0338916278',
          '0.0338349419',
          '0.0339202866',
          '0.0337714687',
          '0.0337402271',
          '0.0336560192',
          '0.0336680907',
          '0.033823288',
          '0.033792812',
          '0.0337207007',
          '0.0335238929',
          '0.0333821216',
          '0.0334187868',
          '0.0331423708',
          '0.0330815152',
          '0.0331336926',
          '0.0329376141',
          '0.0328246826',
          '0.0330378359',
          '0.0332238322',
        ],
        allTimeHigh: { price: '1.1958838420370697', timestamp: 1515110400000 },
        penalty: false,
      },
      {
        id: 14755,
        uuid: 'mqtUpyBxu8O8',
        slug: 'leo-leo',
        symbol: 'LEO*',
        name: 'LEO',
        description:
          'LEO is a token issued by iFinex, which operates cryptocurrency exchange BitFinex among other projects.',
        color: '#063f35',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/12EKqY08r/leo.svg',
        websiteUrl: null,
        socials: [],
        links: [
          {
            name: 'www.bitfinex.com',
            url: 'http://web.archive.org/web/20200411222841/https://www.bitfinex.com/',
            type: 'website',
          },
          {
            name: 'bitfinex',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/bitfinex',
            type: 'twitter',
          },
          {
            name: 'bitfinex1',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/bitfinex1',
            type: 'facebook',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 29,
        numberOfExchanges: 13,
        type: 'coin',
        volume: 7324714,
        marketCap: 1000447247,
        price: '1.01468609',
        circulatingSupply: 985967243,
        totalSupply: 995239762,
        approvedSupply: true,
        firstSeen: 1561471620000,
        change: -0.35,
        rank: 15,
        history: [
          '1.0182462524',
          '1.0199788526',
          '1.0198865832',
          '1.0186427044',
          '1.0195262287',
          '1.0194003344',
          '1.0194908673',
          '1.0193270476',
          '1.0188387224',
          '1.0193999746',
          '1.0191537946',
          '1.0190527813',
          '1.0178863967',
          '1.0171686317',
          '1.019152071',
          '1.0184713661',
          '1.0175352415',
          '1.0171748377',
          '1.0171205297',
          '1.0176145726',
          '1.0173348926',
          '1.0169831436',
          '1.0160666619',
          '1.0169539593',
          '1.0176764485',
          '1.0161724288',
          '1.01468609',
        ],
        allTimeHigh: { price: '1.9049718995580334', timestamp: 1561507200000 },
        penalty: false,
      },
      {
        id: 6,
        uuid: 'f3iaFeCKEmkaZ',
        slug: 'stellar-xlm',
        symbol: 'XLM',
        name: 'Stellar',
        description:
          'Stellar is a public blockchain network that enables cross-border payments at almost no cost. With this financial system they fight poverty and help develop individual potential.',
        color: '#000000',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/78CxK1xsp/Stellar_symbol_black_RGB.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://www.stellar.org/',
        socials: [
          {
            name: 'stellarorg',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/stellarorg',
            type: 'twitter',
          },
          {
            name: 'r/stellar',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/stellar',
            type: 'reddit',
          },
          {
            name: 'BitcoinTalk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=1428573.0',
            type: 'bitcointalk',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/stellarfoundation',
            type: 'facebook',
          },
          {
            name: 'stellar',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/stellar',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'www.stellar.org',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://www.stellar.org/',
          },
          {
            name: 'Staking guide',
            url: 'http://web.archive.org/web/20200411222841/https://www.stakingrewards.com/asset/stellar',
            type: 'website',
          },
          {
            name: 'stellarorg',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/stellarorg',
            type: 'twitter',
          },
          {
            name: 'r/stellar',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/stellar',
            type: 'reddit',
          },
          {
            name: 'BitcoinTalk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=1428573.0',
            type: 'bitcointalk',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/stellarfoundation',
            type: 'facebook',
          },
          {
            name: 'stellar',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/stellar',
            type: 'github',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 569,
        numberOfExchanges: 101,
        type: 'coin',
        volume: 375614233,
        marketCap: 994620646,
        price: '0.0492251855',
        circulatingSupply: 20205523566.63592,
        totalSupply: 49999999738.63592,
        approvedSupply: true,
        firstSeen: 1484611200000,
        change: 3.24,
        rank: 16,
        history: [
          '0.047680221',
          '0.0476066666',
          '0.0476306894',
          '0.0477109325',
          '0.0480049235',
          '0.0486202592',
          '0.048745732',
          '0.0489746292',
          '0.0489554477',
          '0.0491198428',
          '0.0487073681',
          '0.0488751375',
          '0.0487668671',
          '0.0486147214',
          '0.0486682883',
          '0.0488219128',
          '0.0488060717',
          '0.0484559319',
          '0.0485250064',
          '0.0490421164',
          '0.0491400561',
          '0.0493027539',
          '0.04955162',
          '0.0492567285',
          '0.0486800827',
          '0.0488030366',
          '0.0492251855',
        ],
        allTimeHigh: { price: '0.8388618719671962', timestamp: 1515110400000 },
        penalty: false,
      },
      {
        id: 10,
        uuid: '3mVx2FX_iJFp5',
        slug: 'monero-xmr',
        symbol: 'XMR',
        name: 'Monero',
        description:
          'Monero is an anonymous, secure, and untraceable digital currency that is accessible to everyone. It is an anonymous version of Bitcoin. You are your own bank, where only you could control your transactions.',
        color: '#ff7519',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/Syz-oSd_Z/xmr.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://getmonero.org/',
        socials: [
          {
            name: 'monerocurrency',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/monerocurrency',
            type: 'twitter',
          },
          {
            name: 'r/monero',
            url: 'http://web.archive.org/web/20200411222841/https://reddit.com/r/monero',
            type: 'reddit',
          },
          {
            name: 'bitmonero',
            url: 'http://web.archive.org/web/20200411222841/https://telegram.me/bitmonero',
            type: 'telegram',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=583449.0',
            type: 'bitcointalk',
          },
        ],
        links: [
          {
            name: 'monerocurrency',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/monerocurrency',
            type: 'twitter',
          },
          {
            name: 'r/monero',
            url: 'http://web.archive.org/web/20200411222841/https://reddit.com/r/monero',
            type: 'reddit',
          },
          {
            name: 'bitmonero',
            url: 'http://web.archive.org/web/20200411222841/https://telegram.me/bitmonero',
            type: 'telegram',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=583449.0',
            type: 'bitcointalk',
          },
          {
            name: 'getmonero.org',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://getmonero.org/',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 586,
        numberOfExchanges: 84,
        type: 'coin',
        volume: 100879500,
        marketCap: 930295270,
        price: '53.1016165742',
        circulatingSupply: 17519151.579287115,
        totalSupply: 17519151.579287115,
        approvedSupply: true,
        firstSeen: 1422489600000,
        change: -1.29,
        rank: 17,
        history: [
          '53.7963519867',
          '53.700780517',
          '53.5951255452',
          '53.6335789348',
          '53.8306705493',
          '54.0772371134',
          '54.257982627',
          '54.4290602177',
          '54.4540716751',
          '54.5377818992',
          '54.1380760976',
          '54.1926265204',
          '53.905293532',
          '53.6479625972',
          '53.7362542026',
          '53.8071082083',
          '53.5317559317',
          '53.4206458242',
          '53.197837358',
          '53.4021201741',
          '52.8343447112',
          '52.8128363767',
          '52.9209279376',
          '52.6813642022',
          '52.587080177',
          '52.9611886804',
          '53.1016165742',
        ],
        allTimeHigh: { price: '447.98507184923585', timestamp: 1515369600000 },
        penalty: false,
      },
      {
        id: 11,
        uuid: 'qUhEFk1I61atv',
        slug: 'tron-trx',
        symbol: 'TRX',
        name: 'TRON',
        description:
          'TRON is an entertainment data platform. The platform enables content creators to create freely moveable digital assets. By using blockchain technology and distributed storage TRON aims to be completely decentralized.',
        color: '#eb0029',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/behejNqQs/trx.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://tron.network/index?lng=en',
        socials: [
          {
            name: 'tronprotocol',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/tronprotocol',
            type: 'github',
          },
          {
            name: 'tronfoundation',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/tronfoundation',
            type: 'twitter',
          },
          {
            name: 'tronnetworken',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/tronnetworken',
            type: 'telegram',
          },
          {
            name: 'r/tronix',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/tronix/',
            type: 'reddit',
          },
          {
            name: 'Discord',
            url: 'http://web.archive.org/web/20200411222841/https://discordapp.com/invite/gsrgstd',
            type: 'discord',
          },
          {
            name: '@tronfoundation',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/@tronfoundation',
            type: 'medium',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/uc5opogrq02ik-0t9skse_ka',
            type: 'youtube',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/tronfoundation-144555002795817/',
            type: 'facebook',
          },
          {
            name: 'tronfoundation',
            url: 'http://web.archive.org/web/20200411222841/https://www.instagram.com/tronfoundation',
            type: 'instagram',
          },
        ],
        links: [
          {
            name: 'tronprotocol',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/tronprotocol',
            type: 'github',
          },
          {
            name: 'tronfoundation',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/tronfoundation',
            type: 'twitter',
          },
          {
            name: 'tronnetworken',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/tronnetworken',
            type: 'telegram',
          },
          {
            name: 'r/tronix',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/tronix/',
            type: 'reddit',
          },
          {
            name: 'Discord',
            url: 'http://web.archive.org/web/20200411222841/https://discordapp.com/invite/gsrgstd',
            type: 'discord',
          },
          {
            name: '@tronfoundation',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/@tronfoundation',
            type: 'medium',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/uc5opogrq02ik-0t9skse_ka',
            type: 'youtube',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/tronfoundation-144555002795817/',
            type: 'facebook',
          },
          {
            name: 'tronfoundation',
            url: 'http://web.archive.org/web/20200411222841/https://www.instagram.com/tronfoundation',
            type: 'instagram',
          },
          {
            name: 'tron.network',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://tron.network/index?lng=en',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 426,
        numberOfExchanges: 117,
        type: 'coin',
        volume: 455019630,
        marketCap: 823391095,
        price: '0.0124491715',
        circulatingSupply: 66140232427,
        totalSupply: 99281283754,
        approvedSupply: true,
        firstSeen: 1505260800000,
        change: 0.23,
        rank: 18,
        history: [
          '0.0124203584',
          '0.0124340996',
          '0.0124538214',
          '0.0124988313',
          '0.0125765578',
          '0.012643382',
          '0.0126923163',
          '0.0127490429',
          '0.0127338364',
          '0.0127660874',
          '0.0126786602',
          '0.0126606794',
          '0.0126429713',
          '0.0126235926',
          '0.0126552023',
          '0.0126852155',
          '0.0126682297',
          '0.0126031966',
          '0.0125794212',
          '0.0126298723',
          '0.0125187694',
          '0.012471476',
          '0.0124765752',
          '0.012415486',
          '0.0123750441',
          '0.0124056723',
          '0.0124491715',
        ],
        allTimeHigh: { price: '0.2180392689957852', timestamp: 1515196800000 },
        penalty: false,
      },
      {
        id: 10296,
        uuid: '65PHZTpmE55b',
        slug: 'cryptocomchain-cro',
        symbol: 'CRO',
        name: 'Crypto.com Chain',
        description: null,
        color: '#01275d',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/2o91jm73M/cro.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://crypto.com',
        socials: [],
        links: [
          {
            name: 'crypto.com',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://crypto.com',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 57,
        numberOfExchanges: 29,
        type: 'coin',
        volume: 6372983,
        marketCap: 707250751,
        price: '0.0496977201',
        circulatingSupply: 14231050228.310501,
        totalSupply: 100000000000,
        approvedSupply: true,
        firstSeen: 1548953220000,
        change: -0.05,
        rank: 19,
        history: [
          '0.0497247112',
          '0.0495667628',
          '0.0494981783',
          '0.0495968604',
          '0.0497661115',
          '0.0498168878',
          '0.0498826258',
          '0.050000239',
          '0.0499257584',
          '0.0500003824',
          '0.0497385428',
          '0.0497952119',
          '0.0496121233',
          '0.0494328884',
          '0.0494897365',
          '0.0496283652',
          '0.0495451088',
          '0.0493930094',
          '0.0497758091',
          '0.0495319643',
          '0.0493284944',
          '0.0493198639',
          '0.0494336989',
          '0.0493825354',
          '0.0493250135',
          '0.0495264104',
          '0.0496977201',
        ],
        allTimeHigh: { price: '0.10117070724687295', timestamp: 1552608000000 },
        penalty: false,
      },
      {
        id: 1760,
        uuid: 'aKzUVe4Hh_CON',
        slug: 'usdc-usdc',
        symbol: 'USDC',
        name: 'USDC',
        description:
          'USDC is a stablecoin that aims to be financially transparent and open-source. The project is the result of a collaboration between Circle and Coinbase.',
        color: null,
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/jkDf8sQbY/usdc.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://www.centre.io/usdc',
        socials: [
          {
            name: 'centre-blog',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/centre-blog',
            type: 'medium',
          },
          {
            name: 'centre_io',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/centre_io',
            type: 'twitter',
          },
          {
            name: 'centrehq/centre-tokens',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/centrehq/centre-tokens',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'centre-blog',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/centre-blog',
            type: 'medium',
          },
          {
            name: 'centre_io',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/centre_io',
            type: 'twitter',
          },
          {
            name: 'centrehq/centre-tokens',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/centrehq/centre-tokens',
            type: 'github',
          },
          {
            name: 'www.centre.io',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://www.centre.io/usdc',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 486,
        numberOfExchanges: 79,
        type: 'coin',
        volume: 647761337,
        marketCap: 707211830,
        price: '0.9949496633',
        circulatingSupply: 710801617.36,
        totalSupply: 710801617.36,
        approvedSupply: true,
        firstSeen: 1539043200000,
        change: -0.11,
        rank: 20,
        history: [
          '0.9960372056',
          '0.9980647547',
          '0.9983077474',
          '0.9973038839',
          '0.9978406673',
          '0.9973696029',
          '0.9973109936',
          '0.9970964568',
          '0.9950682248',
          '0.9926305661',
          '0.9919507289',
          '0.9918293811',
          '0.99130934',
          '0.9909440205',
          '0.9908716341',
          '0.990810837',
          '0.9906367976',
          '0.9902154571',
          '0.990283108',
          '0.9904101725',
          '0.9894565529',
          '0.9899080098',
          '0.9898434601',
          '0.9920097578',
          '0.996241389',
          '0.9954500798',
          '0.9949496633',
        ],
        allTimeHigh: { price: '1.037812445905387', timestamp: 1539648000000 },
        penalty: false,
      },
      {
        id: 13,
        uuid: 'C9DwH-T7MEGmo',
        slug: 'dash-dash',
        symbol: 'DASH',
        name: 'Dash',
        description:
          'Dash is ‘digital cash’ that works like regular cash, allowing you to exchange your money at a highly secured open source peer-to-peer network, while purchasing items online or in-stores.',
        color: '#1c75bc',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/PyCmduSxt/Dash-D-white_on_blue_circle.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://www.dash.org/',
        socials: [
          {
            name: 'dashpay',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/dashpay',
            type: 'twitter',
          },
          {
            name: 'dash_chat',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/dash_chat',
            type: 'telegram',
          },
          {
            name: 'r/dashpay',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/dashpay',
            type: 'reddit',
          },
          {
            name: 'Discord',
            url: 'http://web.archive.org/web/20200411222841/https://discord.gg/9z8zx5j',
            type: 'discord',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=421615.0',
            type: 'bitcointalk',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/ucazd2v9yx4a4is2_-unodka',
            type: 'youtube',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://facebook.com/dashpay',
            type: 'facebook',
          },
          {
            name: 'dashpay/dash',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/dashpay/dash',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'www.dash.org',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://www.dash.org/',
          },
          {
            name: 'Staking guide',
            url: 'http://web.archive.org/web/20200411222841/https://www.stakingrewards.com/asset/dash',
            type: 'website',
          },
          {
            name: 'dashpay',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/dashpay',
            type: 'twitter',
          },
          {
            name: 'dash_chat',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/dash_chat',
            type: 'telegram',
          },
          {
            name: 'r/dashpay',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/dashpay',
            type: 'reddit',
          },
          {
            name: 'Discord',
            url: 'http://web.archive.org/web/20200411222841/https://discord.gg/9z8zx5j',
            type: 'discord',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=421615.0',
            type: 'bitcointalk',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/ucazd2v9yx4a4is2_-unodka',
            type: 'youtube',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://facebook.com/dashpay',
            type: 'facebook',
          },
          {
            name: 'dashpay/dash',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/dashpay/dash',
            type: 'github',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 601,
        numberOfExchanges: 150,
        type: 'coin',
        volume: 590532823,
        marketCap: 702146653,
        price: '74.4391909203',
        circulatingSupply: 9432486.36287596,
        totalSupply: 9432486.36287596,
        approvedSupply: true,
        firstSeen: 1391817600000,
        change: 1.71,
        rank: 21,
        history: [
          '73.1865962741',
          '73.0806990994',
          '73.6774586788',
          '74.1663403779',
          '74.5175644812',
          '74.7105434256',
          '74.8688848859',
          '75.4645386173',
          '75.3745143616',
          '76.651890914',
          '75.9382854586',
          '75.8296903643',
          '75.3850850837',
          '74.898670556',
          '74.8728803523',
          '75.2452577471',
          '74.9950823079',
          '74.3758812365',
          '74.3024552357',
          '75.0254808063',
          '74.5859162624',
          '74.8116557943',
          '74.7697183287',
          '74.441842821',
          '73.819298901',
          '73.9921044797',
          '74.4391909203',
        ],
        allTimeHigh: { price: '1482.457721896753', timestamp: 1513900800000 },
        penalty: false,
      },
      {
        id: 16,
        uuid: 'hnfQfsYfeIGUQ',
        slug: 'ethereumclassic-etc',
        symbol: 'ETC',
        name: 'Ethereum Classic',
        description:
          'Ethereum Classic is a decentralized smart contracts platform which is a continuation of the Ethereum blockchain. Ethereum Classic preserves original history, excluding external interference and altered transactions.',
        color: '#699070',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/rJfyor__W/etc.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://ethereumclassic.github.io/',
        socials: [],
        links: [
          {
            name: 'ethereumclassic.github.io',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://ethereumclassic.github.io/',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 319,
        numberOfExchanges: 120,
        type: 'coin',
        volume: 1499996783,
        marketCap: 601538485,
        price: '5.2273171342',
        circulatingSupply: 115075950,
        totalSupply: 107988299,
        approvedSupply: true,
        firstSeen: 1469577600000,
        change: -0.39,
        rank: 22,
        history: [
          '5.2476482392',
          '5.2446027785',
          '5.2455275458',
          '5.2545209917',
          '5.2778936991',
          '5.297421676',
          '5.3003303918',
          '5.3395379305',
          '5.3446616824',
          '5.3692441339',
          '5.3312820536',
          '5.3360948698',
          '5.3038192353',
          '5.2810743868',
          '5.2885334831',
          '5.2993867761',
          '5.2785134802',
          '5.2312675345',
          '5.2234843906',
          '5.2624532915',
          '5.2176657658',
          '5.1979426965',
          '5.2165844624',
          '5.2009099253',
          '5.1613660151',
          '5.1943840714',
          '5.2273171342',
        ],
        allTimeHigh: { price: '43.29748020169307', timestamp: 1515974400000 },
        penalty: false,
      },
      {
        id: 15,
        uuid: 'cVaOmQWainv7g',
        slug: 'neo-neo',
        symbol: 'NEO',
        name: 'NEO',
        description:
          'Neo is a distributed smart economy network that utilizes blockchain technology and digital identity. The platform allows digitizing assets and making them self-managed by using smart contracts.',
        color: '#aedb00',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/MgUNVQCeN/neo.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://neo.org/',
        socials: [
          {
            name: 'neo_blockchain',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/neo_blockchain',
            type: 'twitter',
          },
          {
            name: 'r/neo',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/neo/',
            type: 'reddit',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/neosmartecon/',
            type: 'facebook',
          },
          {
            name: 'neo-project',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/neo-project',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'neo.org',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://neo.org/',
          },
          {
            name: 'Staking guide',
            url: 'http://web.archive.org/web/20200411222841/https://www.stakingrewards.com/asset/neo',
            type: 'website',
          },
          {
            name: 'neo_blockchain',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/neo_blockchain',
            type: 'twitter',
          },
          {
            name: 'r/neo',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/neo/',
            type: 'reddit',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/neosmartecon/',
            type: 'facebook',
          },
          {
            name: 'neo-project',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/neo-project',
            type: 'github',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 315,
        numberOfExchanges: 93,
        type: 'coin',
        volume: 323992066,
        marketCap: 525642783,
        price: '7.2804016066',
        circulatingSupply: 72199696,
        totalSupply: 100000000,
        approvedSupply: true,
        firstSeen: 1501891200000,
        change: -1.08,
        rank: 23,
        history: [
          '7.3597185523',
          '7.3247811442',
          '7.2888427436',
          '7.3283336596',
          '7.3809048672',
          '7.4123435603',
          '7.4204431133',
          '7.4961391763',
          '7.4711429468',
          '7.4829898825',
          '7.421979127',
          '7.4375086607',
          '7.4111888784',
          '7.3942228032',
          '7.398104949',
          '7.4194396083',
          '7.3930709304',
          '7.3382069609',
          '7.3267710515',
          '7.3630922328',
          '7.3088534867',
          '7.2778489498',
          '7.2705388468',
          '7.2152709039',
          '7.1909239122',
          '7.2366240617',
          '7.2804016066',
        ],
        allTimeHigh: { price: '169.67828825811074', timestamp: 1516060800000 },
        penalty: false,
      },
      {
        id: 14585,
        uuid: 'TpHE2IShQw-sJ',
        slug: 'algorand-algo',
        symbol: 'ALGO',
        name: 'Algorand',
        description:
          'Algorand is a public blockchain that uses a unique consensus mechanism, called pure proof-of-stake. The company claims that it offers high scalability and that it prevents forks from happening.',
        color: null,
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/lzbmCkUGB/algo.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://algorand.foundation/',
        socials: [],
        links: [
          {
            name: 'algorand.foundation',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://algorand.foundation/',
          },
          {
            name: 'Staking guide',
            url: 'http://web.archive.org/web/20200411222841/https://www.stakingrewards.com/asset/algorand',
            type: 'website',
          },
          {
            name: 'Algorand',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/Algorand',
            type: 'twitter',
          },
          {
            name: 'algorand',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/algorand',
            type: 'telegram',
          },
          {
            name: 'AlgorandOfficial',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/AlgorandOfficial/',
            type: 'reddit',
          },
          {
            name: 'algorand',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/algorand',
            type: 'medium',
          },
          {
            name: 'algorand',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/algorand',
            type: 'youtube',
          },
          {
            name: 'algorand',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/algorand/',
            type: 'facebook',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 69,
        numberOfExchanges: 30,
        type: 'coin',
        volume: 68196386,
        marketCap: 467862052,
        price: '0.176709021',
        circulatingSupply: 2647641017.647336,
        totalSupply: 10000000000,
        approvedSupply: true,
        firstSeen: 1562082540000,
        change: -1.19,
        rank: 24,
        history: [
          '0.1788387785',
          '0.1784535455',
          '0.1780003043',
          '0.178687309',
          '0.1794502564',
          '0.1803635794',
          '0.1829807279',
          '0.183451725',
          '0.1828668047',
          '0.1840407001',
          '0.1829050325',
          '0.1824694761',
          '0.1814138897',
          '0.180556506',
          '0.1804199754',
          '0.1818129514',
          '0.1817283089',
          '0.1801657255',
          '0.1787061437',
          '0.1793564044',
          '0.1768457991',
          '0.1767504919',
          '0.1769184128',
          '0.1753597239',
          '0.1740220203',
          '0.1762343589',
          '0.176709021',
        ],
        allTimeHigh: { price: '1.1159248749973796', timestamp: 1562112000000 },
        penalty: false,
      },
      {
        id: 12,
        uuid: 'LtWwuVANwRzV_',
        slug: 'iota-miota',
        symbol: 'MIOTA',
        name: 'IOTA',
        description:
          "IOTA is a cryptocurrency focused on the internet of things. By using a tangle instead of a blockchain, it achieves a high level of transaction throughput. Besides, the network doesn't charge transaction fees, which makes micro-transactions a reality.",
        color: '#000',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/H1IQ9Bdd-/miota.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/http://iota.org/',
        socials: [
          {
            name: 'Medium',
            url: 'http://web.archive.org/web/20200411222841/https://blog.iota.org/',
            type: 'medium',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/iotatoken/',
            type: 'facebook',
          },
          {
            name: 'iotatoken',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/iotatoken',
            type: 'twitter',
          },
          {
            name: 'r/iota',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/iota/',
            type: 'reddit',
          },
          {
            name: 'iotatangle',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/iotatangle',
            type: 'telegram',
          },
          {
            name: 'iotaledger',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/iotaledger',
            type: 'github',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=1216479.0',
            type: 'bitcointalk',
          },
        ],
        links: [
          {
            name: 'Medium',
            url: 'http://web.archive.org/web/20200411222841/https://blog.iota.org/',
            type: 'medium',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/iotatoken/',
            type: 'facebook',
          },
          {
            name: 'iotatoken',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/iotatoken',
            type: 'twitter',
          },
          {
            name: 'r/iota',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/iota/',
            type: 'reddit',
          },
          {
            name: 'iotatangle',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/iotatangle',
            type: 'telegram',
          },
          {
            name: 'iotaledger',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/iotaledger',
            type: 'github',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=1216479.0',
            type: 'bitcointalk',
          },
          {
            name: 'iota.org',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/http://iota.org/',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 61,
        numberOfExchanges: 19,
        type: 'coin',
        volume: 8077843,
        marketCap: 444001364,
        price: '0.1597397111',
        circulatingSupply: 2779530283,
        totalSupply: 2779530283,
        approvedSupply: true,
        firstSeen: 1497364209000,
        change: -0.54,
        rank: 25,
        history: [
          '0.1606020882',
          '0.1606371687',
          '0.1610346668',
          '0.1620855107',
          '0.1624772763',
          '0.1625679581',
          '0.1632641711',
          '0.1641986949',
          '0.1636680418',
          '0.1640952824',
          '0.1625624331',
          '0.1624605721',
          '0.1616958935',
          '0.1611825283',
          '0.1618247887',
          '0.1627955732',
          '0.16214553',
          '0.1607677765',
          '0.1601291081',
          '0.1606899517',
          '0.1590810336',
          '0.1581305197',
          '0.1581500509',
          '0.1575344672',
          '0.1568520727',
          '0.1584800515',
          '0.1597397111',
        ],
        allTimeHigh: { price: '5.773849630683582', timestamp: 1513641600000 },
        penalty: false,
      },
      {
        id: 4966,
        uuid: 'Knsels4_Ol-Ny',
        slug: 'cosmos-atom',
        symbol: 'ATOM*',
        name: 'Cosmos',
        description:
          'Cosmos is a secure & scalable blockchain ecosystem where thousands of dApps interoperate to create the foundation for a new token economy.',
        color: '#5064fb',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/HJzHboruM/atom.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://cosmos.network',
        socials: [
          {
            name: 'cosmos',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/cosmos',
            type: 'twitter',
          },
          {
            name: 'cosmosproject',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/cosmosproject',
            type: 'telegram',
          },
          {
            name: 'r/cosmosnetwork',
            url: 'http://web.archive.org/web/20200411222841/https://reddit.com/r/cosmosnetwork',
            type: 'reddit',
          },
          {
            name: 'Medium',
            url: 'http://web.archive.org/web/20200411222841/https://blog.cosmos.network/',
            type: 'medium',
          },
          {
            name: 'CosmosProject',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/c/CosmosProject',
            type: 'youtube',
          },
        ],
        links: [
          {
            name: 'cosmos.network',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://cosmos.network',
          },
          {
            name: 'Staking guide',
            url: 'http://web.archive.org/web/20200411222841/https://www.stakingrewards.com/asset/cosmos',
            type: 'website',
          },
          {
            name: 'Rewards calculator',
            url: 'http://web.archive.org/web/20200411222841/https://stake.fish/en/cosmos/calculator/',
            type: 'website',
          },
          {
            name: 'Validators leaderboard',
            url: 'http://web.archive.org/web/20200411222841/https://cosmos.fish/leaderboard',
            type: 'website',
          },
          {
            name: 'cosmos',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/cosmos',
            type: 'twitter',
          },
          {
            name: 'cosmosproject',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/cosmosproject',
            type: 'telegram',
          },
          {
            name: 'r/cosmosnetwork',
            url: 'http://web.archive.org/web/20200411222841/https://reddit.com/r/cosmosnetwork',
            type: 'reddit',
          },
          {
            name: 'Medium',
            url: 'http://web.archive.org/web/20200411222841/https://blog.cosmos.network/',
            type: 'medium',
          },
          {
            name: 'CosmosProject',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/c/CosmosProject',
            type: 'youtube',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 89,
        numberOfExchanges: 35,
        type: 'coin',
        volume: 107111709,
        marketCap: 422846858,
        price: '2.2798403518',
        circulatingSupply: 185472135.109866,
        totalSupply: 253888505.723165,
        approvedSupply: true,
        firstSeen: 1552520100000,
        change: -0.89,
        rank: 26,
        history: [
          '2.3002107847',
          '2.3032538675',
          '2.3059461134',
          '2.3163085646',
          '2.3348060642',
          '2.349246062',
          '2.3607503633',
          '2.3677444486',
          '2.3515334786',
          '2.3635943446',
          '2.3410117089',
          '2.3351128536',
          '2.3130929887',
          '2.2983620152',
          '2.3064435739',
          '2.3113830498',
          '2.2998639607',
          '2.2807433172',
          '2.2762517691',
          '2.2903734304',
          '2.2673908291',
          '2.263416383',
          '2.2658336419',
          '2.2545838246',
          '2.2525797955',
          '2.2664260626',
          '2.2798403518',
        ],
        allTimeHigh: { price: '7.074884543027061', timestamp: 1552608000000 },
        penalty: false,
      },
      {
        id: 21,
        uuid: 'aRGRWLf2RYNq4',
        slug: 'zcash-zec',
        symbol: 'ZEC',
        name: 'Zcash',
        description:
          'Zcash is a fully anonymous and decentralized cryptocurrency. Transactions on its proof of work blockchain are untraceable because of zero-knowledge cryptography.',
        color: '#000',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/rJrKiS_uZ/zec.svg',
        websiteUrl: 'http://web.archive.org/web/20200411222841/https://z.cash/',
        socials: [
          {
            name: 'zcashco',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/zcashco',
            type: 'twitter',
          },
          {
            name: 'r/zec',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/zec/',
            type: 'reddit',
          },
          {
            name: 'zcash',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/zcash',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'z.cash',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://z.cash/',
          },
          {
            name: 'electriccoinco',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/electriccoinco',
            type: 'twitter',
          },
          {
            name: 'r/zec',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/zec/',
            type: 'reddit',
          },
          {
            name: 'zcash',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/zcash',
            type: 'github',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 350,
        numberOfExchanges: 112,
        type: 'coin',
        volume: 451769753,
        marketCap: 353234535,
        price: '36.1169658312',
        circulatingSupply: 9780293.75,
        totalSupply: 9780293.75,
        approvedSupply: true,
        firstSeen: 1477612800000,
        change: 0.13,
        rank: 27,
        history: [
          '36.0689433',
          '36.0508642066',
          '36.2967662574',
          '36.3285794268',
          '36.5083423196',
          '36.7419273338',
          '36.6994855383',
          '36.8643702079',
          '36.8164363603',
          '37.054473632',
          '36.6500374803',
          '36.7145439637',
          '36.3759665679',
          '36.2840644014',
          '36.2953963219',
          '36.3072447135',
          '36.1542432258',
          '36.006985587',
          '36.0001925627',
          '36.2102710752',
          '35.9719477712',
          '35.8008228317',
          '35.8553397214',
          '35.673483025',
          '35.4856388607',
          '35.8071880265',
          '36.1169658312',
        ],
        allTimeHigh: { price: '5000.000001019066', timestamp: 1477612800000 },
        penalty: false,
      },
      {
        id: 22,
        uuid: 'qFakph2rpuMOL',
        slug: 'maker-mkr',
        symbol: 'MKR',
        name: 'Maker',
        description:
          'Maker is a token on the Ethereum blockchain with an aim to govern, secure and support the Dai Stable Coin system (DCS).',
        color: '#1abc9c',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/sjHfS7jCS/mkrdao.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://makerdao.com',
        socials: [
          {
            name: 'makerdao',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/makerdao/',
            type: 'github',
          },
          {
            name: 'r/makerdao',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/makerdao/',
            type: 'reddit',
          },
          {
            name: '@makerdao',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/@makerdao',
            type: 'medium',
          },
        ],
        links: [
          {
            name: 'makerdao',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/makerdao/',
            type: 'github',
          },
          {
            name: 'r/makerdao',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/makerdao/',
            type: 'reddit',
          },
          {
            name: '@makerdao',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/@makerdao',
            type: 'medium',
          },
          {
            name: 'makerdao.com',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://makerdao.com',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 111,
        numberOfExchanges: 50,
        type: 'coin',
        volume: 2450307,
        marketCap: 267741263,
        price: '301.5588935467',
        circulatingSupply: 887857.2939084211,
        totalSupply: 1005850.7578026188,
        approvedSupply: true,
        firstSeen: 1502236800000,
        change: -0.25,
        rank: 28,
        history: [
          '302.3055209389',
          '301.6627473235',
          '301.4799855631',
          '301.0170432319',
          '302.7567208644',
          '304.5490844465',
          '302.8254065426',
          '302.1082113957',
          '304.7159336842',
          '307.9600306608',
          '305.3130709348',
          '307.0937827142',
          '308.4979725083',
          '296.1330137885',
          '307.7454158545',
          '305.4333207226',
          '303.665026599',
          '304.0399655271',
          '306.0419923188',
          '305.9696646937',
          '301.6191167648',
          '302.7552827552',
          '306.9944428973',
          '303.8075710915',
          '300.8969676233',
          '306.8059992764',
          '301.5588935467',
        ],
        allTimeHigh: { price: '4383.449996185815', timestamp: 1502841600000 },
        penalty: false,
      },
      {
        id: 17,
        uuid: 'DZtb-6X8yCx0h',
        slug: 'nem-xem',
        symbol: 'XEM',
        name: 'NEM',
        description:
          'NEM is a configurable blockchain which implements an enterprise blockchain data system, whilst minimizing its complexity to integrate seamlessly with other existing systems.',
        color: '#67b2e8',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/Bkvu9rOOZ/xem.svg',
        websiteUrl: 'http://web.archive.org/web/20200411222841/https://nem.io/',
        socials: [
          {
            name: 'nemofficial',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/nemofficial',
            type: 'twitter',
          },
          {
            name: 'nemred',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/nemred',
            type: 'telegram',
          },
          {
            name: 'r/nem',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/nem/',
            type: 'reddit',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=654845.new#new',
            type: 'bitcointalk',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/ournem/',
            type: 'facebook',
          },
          {
            name: 'nemproject',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/nemproject',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'nem.io',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://nem.io/',
          },
          {
            name: 'Staking guide',
            url: 'http://web.archive.org/web/20200411222841/https://www.stakingrewards.com/asset/nem',
            type: 'website',
          },
          {
            name: 'nemofficial',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/nemofficial',
            type: 'twitter',
          },
          {
            name: 'nemred',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/nemred',
            type: 'telegram',
          },
          {
            name: 'r/nem',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/nem/',
            type: 'reddit',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=654845.new#new',
            type: 'bitcointalk',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/ournem/',
            type: 'facebook',
          },
          {
            name: 'nemproject',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/nemproject',
            type: 'github',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 169,
        numberOfExchanges: 61,
        type: 'coin',
        volume: 19303209,
        marketCap: 256915312,
        price: '0.0363038563',
        circulatingSupply: 7076805001.4966,
        totalSupply: 8999999999,
        approvedSupply: true,
        firstSeen: 1496361600000,
        change: -1.97,
        rank: 29,
        history: [
          '0.037033663',
          '0.0369946258',
          '0.0370281486',
          '0.0370369846',
          '0.0371604714',
          '0.0372304986',
          '0.0370581806',
          '0.0369755756',
          '0.0368681932',
          '0.0369503005',
          '0.0367037383',
          '0.0366694139',
          '0.0365538067',
          '0.0365833261',
          '0.0367396618',
          '0.0368008592',
          '0.0366567911',
          '0.0365370728',
          '0.0364026862',
          '0.0364701943',
          '0.0361644137',
          '0.0362508021',
          '0.0361965579',
          '0.0361553228',
          '0.0360946219',
          '0.0362981227',
          '0.0363038563',
        ],
        allTimeHigh: { price: '1.80823794274015', timestamp: 1515110400000 },
        penalty: false,
      },
      {
        id: 26,
        uuid: 'itpeyyriqoiG2',
        slug: 'ontology-ont',
        symbol: 'ONT',
        name: 'Ontology',
        description:
          "Ontology aims to be a peer to peer trust network with a cross-chain, cross-app, cross-industry and cross-device distributed trust system, that has incorporated various trust types in an integrated multi-source protocol system. The ONT tokens are utility tokens giving access to Ontology's distributed services.",
        color: '#32a4be',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/rJHf0aixm/ont.svg',
        websiteUrl: 'http://web.archive.org/web/20200411222841/https://ont.io',
        socials: [
          {
            name: 'ontologynetwork',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/ontologynetwork',
            type: 'medium',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/ontology-network-468098413590227/',
            type: 'facebook',
          },
          {
            name: 'ontologynetwork',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/ontologynetwork',
            type: 'twitter',
          },
          {
            name: 'r/ontologynetwork',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/ontologynetwork/',
            type: 'reddit',
          },
          {
            name: 'ontologynetworkcn',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/ontologynetworkcn',
            type: 'telegram',
          },
          {
            name: 'Discord',
            url: 'http://web.archive.org/web/20200411222841/https://discord.gg/4tqujhj',
            type: 'discord',
          },
        ],
        links: [
          {
            name: 'ontologynetwork',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/ontologynetwork',
            type: 'medium',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/ontology-network-468098413590227/',
            type: 'facebook',
          },
          {
            name: 'ontologynetwork',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/ontologynetwork',
            type: 'twitter',
          },
          {
            name: 'r/ontologynetwork',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/ontologynetwork/',
            type: 'reddit',
          },
          {
            name: 'ontologynetworkcn',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/ontologynetworkcn',
            type: 'telegram',
          },
          {
            name: 'Discord',
            url: 'http://web.archive.org/web/20200411222841/https://discord.gg/4tqujhj',
            type: 'discord',
          },
          {
            name: 'ont.io',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://ont.io',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 132,
        numberOfExchanges: 50,
        type: 'coin',
        volume: 71987558,
        marketCap: 255248734,
        price: '0.4004836675',
        circulatingSupply: 637351170,
        totalSupply: 1000000000,
        approvedSupply: true,
        firstSeen: 1520553600000,
        change: -0.55,
        rank: 30,
        history: [
          '0.4027076364',
          '0.4014734187',
          '0.4007466763',
          '0.4024391881',
          '0.4056540349',
          '0.4083189457',
          '0.4088506568',
          '0.4115710558',
          '0.4098997239',
          '0.4101299279',
          '0.406438224',
          '0.4061291202',
          '0.4041869099',
          '0.4035384348',
          '0.4046160782',
          '0.4043794386',
          '0.4026997791',
          '0.4007639421',
          '0.4012671678',
          '0.4027439411',
          '0.3996205196',
          '0.4000683934',
          '0.4002247097',
          '0.397672654',
          '0.3956127786',
          '0.3982047197',
          '0.4004836675',
        ],
        allTimeHigh: { price: '9.978061692854286', timestamp: 1525392000000 },
        penalty: false,
      },
      {
        id: 1694,
        uuid: 'B8xT718SbVhhh',
        slug: 'paxosstandard-pax',
        symbol: 'PAX',
        name: 'Paxos Standard',
        description: null,
        color: '#085229',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/H1NkFcuhX/pax.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://www.paxos.com/standard/',
        socials: [
          {
            name: '@paxosstandard',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/@paxosstandard',
            type: 'medium',
          },
          {
            name: 'paxosstandard',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/paxosstandard',
            type: 'twitter',
          },
          {
            name: 'paxosglobal/pax-contracts',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/paxosglobal/pax-contracts',
            type: 'github',
          },
        ],
        links: [
          {
            name: '@paxosstandard',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/@paxosstandard',
            type: 'medium',
          },
          {
            name: 'paxosstandard',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/paxosstandard',
            type: 'twitter',
          },
          {
            name: 'paxosglobal/pax-contracts',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/paxosglobal/pax-contracts',
            type: 'github',
          },
          {
            name: 'www.paxos.com',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://www.paxos.com/standard/',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 288,
        numberOfExchanges: 65,
        type: 'coin',
        volume: 897337267,
        marketCap: 254882114,
        price: '0.997338032',
        circulatingSupply: 255562412.47,
        totalSupply: 255562412.47,
        approvedSupply: true,
        firstSeen: 1539302400000,
        change: -0.08,
        rank: 31,
        history: [
          '0.9981176918',
          '1.0006052512',
          '1.000529891',
          '0.998774423',
          '0.9993376801',
          '0.9988924321',
          '0.9987410766',
          '0.9984587145',
          '0.9980353203',
          '0.9984762828',
          '0.9988129445',
          '0.9985991133',
          '0.9979239211',
          '0.9977795329',
          '0.9973953618',
          '0.9974278748',
          '0.9978743606',
          '0.9983950599',
          '0.9984261557',
          '0.9979863309',
          '0.9981180115',
          '0.9985206198',
          '0.9983898026',
          '0.9992157425',
          '0.9999250807',
          '0.9979464551',
          '0.997338032',
        ],
        allTimeHigh: { price: '1.0452913623048152', timestamp: 1539648000000 },
        penalty: false,
      },
      {
        id: 62569,
        uuid: 'NfeOYfNcl',
        slug: 'ftxtoken-ftt',
        symbol: 'FTT**',
        name: 'FTX Token',
        description: null,
        color: null,
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/WyBm4_EzM/ftx-exchange.svg',
        websiteUrl: null,
        socials: [],
        links: [
          {
            name: 'ftx.com',
            url: 'http://web.archive.org/web/20200411222841/https://ftx.com/',
            type: 'website',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 13,
        numberOfExchanges: 7,
        type: 'coin',
        volume: 1145400,
        marketCap: 253137052,
        price: '2.5164950846',
        circulatingSupply: 100591117.18167877,
        totalSupply: 346445680.99999994,
        approvedSupply: true,
        firstSeen: 1566222960000,
        change: -1.12,
        rank: 32,
        history: [
          '2.5450936255',
          '2.5348176183',
          '2.5240757562',
          '2.5309376332',
          '2.5419421114',
          '2.5453671081',
          '2.5500249964',
          '2.5582371401',
          '2.5559779805',
          '2.559536651',
          '2.5413304891',
          '2.5397509366',
          '2.5322412586',
          '2.526848525',
          '2.5300563172',
          '2.5379945085',
          '2.5323076713',
          '2.5195201193',
          '2.5181269461',
          '2.5238329196',
          '2.5064124759',
          '2.5026052883',
          '2.5063971127',
          '2.4980564294',
          '2.4943416379',
          '2.5081619766',
          '2.5164950846',
        ],
        allTimeHigh: { price: '2.814952975073917', timestamp: 1582070400000 },
        penalty: false,
      },
      {
        id: 20,
        uuid: 'a91GCGd_u96cF',
        slug: 'dogecoin-doge',
        symbol: 'DOGE',
        name: 'Dogecoin',
        description:
          'Dogecoin is the famous Doge internet meme turned into a full-fledged cryptocurrency. It is created to be a joke currency but it grew into something bigger and more serious than intended.',
        color: '#c2a633',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/H1arXIuOZ/doge.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/http://dogecoin.com/',
        socials: [
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/officialdogecoin/',
            type: 'facebook',
          },
          {
            name: 'dogecoin',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/dogecoin',
            type: 'twitter',
          },
          {
            name: 'r/dogecoin',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/dogecoin/',
            type: 'reddit',
          },
          {
            name: 'dogecoin/dogecoin',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/dogecoin/dogecoin',
            type: 'github',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=361813.0',
            type: 'bitcointalk',
          },
        ],
        links: [
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/officialdogecoin/',
            type: 'facebook',
          },
          {
            name: 'dogecoin',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/dogecoin',
            type: 'twitter',
          },
          {
            name: 'r/dogecoin',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/dogecoin/',
            type: 'reddit',
          },
          {
            name: 'dogecoin/dogecoin',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/dogecoin/dogecoin',
            type: 'github',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=361813.0',
            type: 'bitcointalk',
          },
          {
            name: 'dogecoin.com',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/http://dogecoin.com/',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 2218,
        numberOfExchanges: 109,
        type: 'coin',
        volume: 119836658,
        marketCap: 247130552,
        price: '0.0019914511',
        circulatingSupply: 124095717448.46022,
        totalSupply: 124095717448.46022,
        approvedSupply: true,
        firstSeen: 1391212800000,
        change: -0.42,
        rank: 33,
        history: [
          '0.0019998117',
          '0.0019846222',
          '0.0019650032',
          '0.0019692604',
          '0.0019826474',
          '0.0019791539',
          '0.0019738259',
          '0.0019898908',
          '0.001983052',
          '0.0019841959',
          '0.0019710194',
          '0.001975729',
          '0.0019813503',
          '0.0019694881',
          '0.0019707015',
          '0.0019735674',
          '0.0019773419',
          '0.0019711541',
          '0.0019684365',
          '0.0019711548',
          '0.0019552487',
          '0.0019516491',
          '0.0019546882',
          '0.0019528908',
          '0.0019470215',
          '0.0019612582',
          '0.0019914511',
        ],
        allTimeHigh: {
          price: '0.016338695524703146',
          timestamp: 1515369600000,
        },
        penalty: false,
      },
      {
        id: 19,
        uuid: 'FEbS54wxo4oIl',
        slug: 'vechain-vet',
        symbol: 'VET',
        name: 'VeChain',
        description:
          'Vechain is a blockchain platform focused on creating an ecosystem which can be used by enterprises for products and information. The ecosystem enables transparency and symmetrical information. The VeChain token is called VET and serves as fuel in the VeChain platform.',
        color: '#4bc0fa',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/B1_TDu9Dm/VEN.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://www.vechain.com',
        socials: [
          {
            name: '@vechainofficial',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/@vechainofficial',
            type: 'medium',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/vechain/',
            type: 'facebook',
          },
          {
            name: 'vechainofficial',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/vechainofficial',
            type: 'twitter',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/ucqkewpu5hkel4o3sxlj3n5a',
            type: 'youtube',
          },
          {
            name: 'vechain_official_english',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/vechain_official_english',
            type: 'telegram',
          },
          {
            name: 'Discord',
            url: 'http://web.archive.org/web/20200411222841/https://discordapp.com/invite/hhvxvux',
            type: 'discord',
          },
          {
            name: 'vechain/thor',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/vechain/thor',
            type: 'github',
          },
        ],
        links: [
          {
            name: '@vechainofficial',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/@vechainofficial',
            type: 'medium',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/vechain/',
            type: 'facebook',
          },
          {
            name: 'vechainofficial',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/vechainofficial',
            type: 'twitter',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/ucqkewpu5hkel4o3sxlj3n5a',
            type: 'youtube',
          },
          {
            name: 'vechain_official_english',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/vechain_official_english',
            type: 'telegram',
          },
          {
            name: 'Discord',
            url: 'http://web.archive.org/web/20200411222841/https://discordapp.com/invite/hhvxvux',
            type: 'discord',
          },
          {
            name: 'vechain/thor',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/vechain/thor',
            type: 'github',
          },
          {
            name: 'www.vechain.com',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://www.vechain.com',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 121,
        numberOfExchanges: 37,
        type: 'coin',
        volume: 107695319,
        marketCap: 235287537,
        price: '0.003652178',
        circulatingSupply: 64423896728,
        totalSupply: 85985041177,
        approvedSupply: true,
        firstSeen: 1533427200000,
        change: 2.68,
        rank: 34,
        history: [
          '0.0035568593',
          '0.0035691519',
          '0.0035858274',
          '0.0036039213',
          '0.0036442338',
          '0.0036948833',
          '0.003695512',
          '0.003728658',
          '0.0037366264',
          '0.0037174115',
          '0.0036857791',
          '0.0036764637',
          '0.0036570923',
          '0.0036520172',
          '0.0036823811',
          '0.0037132288',
          '0.003709972',
          '0.0036802316',
          '0.003656816',
          '0.0036748347',
          '0.0036405224',
          '0.0036211325',
          '0.0036346742',
          '0.0036075053',
          '0.0035737018',
          '0.0036021437',
          '0.003652178',
        ],
        allTimeHigh: {
          price: '0.019334313915837613',
          timestamp: 1536105600000,
        },
        penalty: false,
      },
      {
        id: 46,
        uuid: 'pOnT-qfd-RN7W',
        slug: 'basicattentiontoken-bat',
        symbol: 'BAT',
        name: 'Basic Attention Token',
        description:
          'Basic Attention Token aims to improve the digital advertising industry. They will achieve this by creating a decentralized ad exchange where publishers will be paid for their content and users for their attention, while providing advertisers with less expensive customer attention, less fraud, and better attribution.',
        color: '#9e1f63',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/SyX3N05JQ/bat.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://basicattentiontoken.org/',
        socials: [
          {
            name: '@attentiontoken',
            url: 'http://web.archive.org/web/20200411222841/http://medium.com/@attentiontoken',
            type: 'medium',
          },
          {
            name: 'attentiontoken',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/attentiontoken',
            type: 'twitter',
          },
          {
            name: 'r/batproject',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/batproject/',
            type: 'reddit',
          },
        ],
        links: [
          {
            name: '@attentiontoken',
            url: 'http://web.archive.org/web/20200411222841/http://medium.com/@attentiontoken',
            type: 'medium',
          },
          {
            name: 'attentiontoken',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/attentiontoken',
            type: 'twitter',
          },
          {
            name: 'r/batproject',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/batproject/',
            type: 'reddit',
          },
          {
            name: 'basicattentiontoken.org',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://basicattentiontoken.org/',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 289,
        numberOfExchanges: 103,
        type: 'coin',
        volume: 62066190,
        marketCap: 230480936,
        price: '0.1581352398',
        circulatingSupply: 1457492563.5663028,
        totalSupply: 1500000000,
        approvedSupply: true,
        firstSeen: 1496275200000,
        change: -3.03,
        rank: 35,
        history: [
          '0.1630832139',
          '0.1622671747',
          '0.1608120751',
          '0.1607234504',
          '0.1615839914',
          '0.1631913314',
          '0.1649419379',
          '0.1661991175',
          '0.1658068352',
          '0.1663308235',
          '0.1638787639',
          '0.1628755001',
          '0.1622695489',
          '0.1623001665',
          '0.161268226',
          '0.16149955',
          '0.1626272195',
          '0.1615474579',
          '0.1611847072',
          '0.1619708799',
          '0.1592070396',
          '0.1590869294',
          '0.15911134',
          '0.1578280144',
          '0.1583639987',
          '0.1590850043',
          '0.1581352398',
        ],
        allTimeHigh: { price: '0.8821450003815525', timestamp: 1515542400000 },
        penalty: false,
      },
      {
        id: 422,
        uuid: '3dEOkxpEKhmBT',
        slug: 'numeraire-nmr',
        symbol: 'NMR',
        name: 'Numeraire',
        description:
          'Numerai aims to use smart contracts an auction mechanism and Numeraire tokens as an incentive reward tokens in order to create an artificial intelligence hedge fund for data scientists. The Numeraire ERC20 tokens on the Ethereum Blockchain work as a reward token for Data scientist and an utility token giving access to the Numerai smart contracts and machine learning tournaments.',
        color: null,
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/Bk6eoUOuZ/nmr.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://numer.ai/',
        socials: [
          {
            name: 'numerai',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/numerai',
            type: 'twitter',
          },
          {
            name: 'r/numerai',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/numerai/',
            type: 'reddit',
          },
          {
            name: 'numerai',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/numerai',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'numerai',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/numerai',
            type: 'twitter',
          },
          {
            name: 'r/numerai',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/numerai/',
            type: 'reddit',
          },
          {
            name: 'numerai',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/numerai',
            type: 'github',
          },
          {
            name: 'numer.ai',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://numer.ai/',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 11,
        numberOfExchanges: 9,
        type: 'coin',
        volume: 184190,
        marketCap: 168007830,
        price: '16.8215475447',
        circulatingSupply: 9987656.009716481,
        totalSupply: 10987476.06011506,
        approvedSupply: true,
        firstSeen: 1498176000000,
        change: 12.77,
        rank: 36,
        history: [
          '14.9164680843',
          '14.9077110939',
          '14.8365066571',
          '14.8723646474',
          '15.0081851595',
          '15.1241566127',
          '15.16620292',
          '15.2375555472',
          '15.1003962823',
          '15.1347306275',
          '14.9459582022',
          '14.8987358786',
          '14.8518651214',
          '14.7546562173',
          '14.741160845',
          '14.8043696541',
          '14.7160824299',
          '14.6143533199',
          '14.6512617696',
          '14.4159623135',
          '14.331691842',
          '14.5197973832',
          '14.6358524281',
          '15.002532569',
          '16.7205806749',
          '16.8528165737',
          '16.8215475447',
        ],
        allTimeHigh: { price: '103.59999988396575', timestamp: 1498262400000 },
        penalty: false,
      },
      {
        id: 23,
        uuid: '1rnjJ1rInKP5K',
        slug: 'bitcoingold-btg',
        symbol: 'BTG',
        name: 'Bitcoin Gold',
        description:
          'Bitcoin Gold is a hard fork of the open source Bitcoin code. The blockchain network aims to decentralize mining by using a hashing algorithm called Equihash, rendering specialised mining equipment obsolete in an attempt to further democratise the Bitcoin mining process.',
        color: '#021e6b',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/BkLedkw-G/btg.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://bitcoingold.org',
        socials: [
          {
            name: '@btcgpu',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/@btcgpu',
            type: 'medium',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/bitcoingoldofficial/',
            type: 'facebook',
          },
          {
            name: 'bitcoingold',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/bitcoingold',
            type: 'twitter',
          },
          {
            name: 'r/bitcoingoldhq',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/bitcoingoldhq',
            type: 'reddit',
          },
          {
            name: 'Discord',
            url: 'http://web.archive.org/web/20200411222841/https://discord.gg/hmvuu6s',
            type: 'discord',
          },
          {
            name: 'btcgpu/btcgpu',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/btcgpu/btcgpu',
            type: 'github',
          },
        ],
        links: [
          {
            name: '@btcgpu',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/@btcgpu',
            type: 'medium',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/bitcoingoldofficial/',
            type: 'facebook',
          },
          {
            name: 'bitcoingold',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/bitcoingold',
            type: 'twitter',
          },
          {
            name: 'r/bitcoingoldhq',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/bitcoingoldhq',
            type: 'reddit',
          },
          {
            name: 'Discord',
            url: 'http://web.archive.org/web/20200411222841/https://discord.gg/hmvuu6s',
            type: 'discord',
          },
          {
            name: 'btcgpu/btcgpu',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/btcgpu/btcgpu',
            type: 'github',
          },
          {
            name: 'bitcoingold.org',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://bitcoingold.org',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 151,
        numberOfExchanges: 65,
        type: 'coin',
        volume: 37105409,
        marketCap: 166975861,
        price: '9.618924402',
        circulatingSupply: 17359099,
        totalSupply: 17458599,
        approvedSupply: true,
        firstSeen: 1508803200000,
        change: 7.04,
        rank: 37,
        history: [
          '8.9858888471',
          '8.9150697713',
          '8.8912708735',
          '9.1897877567',
          '9.4041042022',
          '9.5333352887',
          '9.6250985583',
          '9.8190317334',
          '9.862042955',
          '9.7707954646',
          '9.5325242232',
          '9.5673977243',
          '9.4986582198',
          '9.483192675',
          '9.4668014829',
          '9.5792246932',
          '9.6067455104',
          '9.4770651037',
          '9.4487079027',
          '9.5458868872',
          '9.4768014624',
          '9.4717085485',
          '9.5758972144',
          '9.5461735257',
          '9.5936529565',
          '9.5963514625',
          '9.618924402',
        ],
        allTimeHigh: { price: '424.2354135868738', timestamp: 1513814400000 },
        penalty: false,
      },
      {
        id: 64962,
        uuid: 'Of-8L640D',
        slug: 'orchidprotocol-oxt',
        symbol: 'OXT',
        name: 'Orchid Protocol',
        description:
          'Orchid is an open source VPN protocol, that enables internet without surveillance and censorship. Nodes that operate the network are incentivized by the OXT token.',
        color: '#5f45ba',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/WsG43AdrY/orchid.svg',
        websiteUrl: null,
        socials: [],
        links: [
          {
            name: 'orchid.com',
            url: 'http://web.archive.org/web/20200411222841/https://www.orchid.com',
            type: 'website',
          },
          {
            name: 'OrchidProtocol',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/OrchidProtocol',
            type: 'twitter',
          },
          {
            name: 'OrchidOfficial',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/OrchidOfficial',
            type: 'telegram',
          },
          {
            name: 'orchid-labs',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/orchid-labs',
            type: 'medium',
          },
          {
            name: 'OrchidProtocol',
            url: 'http://web.archive.org/web/20200411222841/https://facebook.com/OrchidProtocol',
            type: 'facebook',
          },
          {
            name: 'OrchidTechnologies',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/OrchidTechnologies',
            type: 'github',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 14,
        numberOfExchanges: 10,
        type: 'coin',
        volume: 4131190,
        marketCap: 163859229,
        price: '0.163859229',
        circulatingSupply: 1000000000,
        totalSupply: 1000000000,
        approvedSupply: true,
        firstSeen: 1576774440000,
        change: -3.27,
        rank: 38,
        history: [
          '0.169393054',
          '0.1696283586',
          '0.1708657789',
          '0.1717279043',
          '0.1706642922',
          '0.1693962877',
          '0.1684899398',
          '0.164703868',
          '0.1638306344',
          '0.1668697253',
          '0.168997583',
          '0.1696416929',
          '0.1663228591',
          '0.1663990009',
          '0.1668371089',
          '0.1653999872',
          '0.1643198872',
          '0.1634591785',
          '0.163300177',
          '0.1623972164',
          '0.1612585443',
          '0.1612584817',
          '0.1601618535',
          '0.1590596618',
          '0.1592466797',
          '0.1610195503',
          '0.163859229',
        ],
        allTimeHigh: { price: '0.6859662968635362', timestamp: 1576800000000 },
        penalty: false,
      },
      {
        id: 58,
        uuid: 'PZLtXypWXRmQ7',
        slug: 'cryptonex-cnx',
        symbol: 'CNX',
        name: 'Cryptonex',
        description:
          'Cryptonex is a cryptocurrency built on its own blockchain that aims to provide a decentralized and global market for fiat currencies and cryptocurrencies.',
        color: '#228cc1',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/S12KybHNf/cnx.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://cryptonex.org',
        socials: [
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/redirect?q=https%3a%2f%2fwww.facebook.com%2fcryptonex.org%2f&redir_token=evmesbdzmobklj-syaxskqnwn458mtuwnzkzndcznuaxnta3odq4mzm1&v=c78j_keem5e&event=video_description',
            type: 'facebook',
          },
          {
            name: 'cryptonex_cnx',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/cryptonex_cnx',
            type: 'twitter',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/uc-fmls489lv845plylfj6eg',
            type: 'youtube',
          },
          {
            name: 'cryptonexcnx',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/cryptonexcnx',
            type: 'telegram',
          },
          {
            name: 'cryptonex',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/cryptonex',
            type: 'github',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=2087904.0',
            type: 'bitcointalk',
          },
        ],
        links: [
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/redirect?q=https%3a%2f%2fwww.facebook.com%2fcryptonex.org%2f&redir_token=evmesbdzmobklj-syaxskqnwn458mtuwnzkzndcznuaxnta3odq4mzm1&v=c78j_keem5e&event=video_description',
            type: 'facebook',
          },
          {
            name: 'cryptonex_cnx',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/cryptonex_cnx',
            type: 'twitter',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/uc-fmls489lv845plylfj6eg',
            type: 'youtube',
          },
          {
            name: 'cryptonexcnx',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/cryptonexcnx',
            type: 'telegram',
          },
          {
            name: 'cryptonex',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/cryptonex',
            type: 'github',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=2087904.0',
            type: 'bitcointalk',
          },
          {
            name: 'cryptonex.org',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://cryptonex.org',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 24,
        numberOfExchanges: 3,
        type: 'coin',
        volume: 1571981,
        marketCap: 163111175,
        price: '1.6311117464',
        circulatingSupply: 100000000,
        totalSupply: 100000000,
        approvedSupply: true,
        firstSeen: 1504224000000,
        change: -0.64,
        rank: 39,
        history: [
          '1.6416638124',
          '1.636304052',
          '1.6320957093',
          '1.6360844748',
          '1.6428320507',
          '1.6444050197',
          '1.643649665',
          '1.6471760867',
          '1.6456929138',
          '1.6470027151',
          '1.6357371841',
          '1.638144067',
          '1.632331574',
          '1.6297917116',
          '1.6336749669',
          '1.6353687684',
          '1.6322873759',
          '1.6251673074',
          '1.6243334486',
          '1.626487462',
          '1.6177532283',
          '1.6163424214',
          '1.6171223311',
          '1.6149242851',
          '1.6134769626',
          '1.6245847906',
          '1.6311117464',
        ],
        allTimeHigh: { price: '9.812700378221288', timestamp: 1517184000000 },
        penalty: false,
      },
      {
        id: 4157,
        uuid: 'CxmvOsCyENPso',
        slug: 'zbtoken-zb',
        symbol: 'ZB',
        name: 'ZB Token',
        description: null,
        color: null,
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/VhtrNhSv7/ZB.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://www.zb.com/',
        socials: [],
        links: [
          {
            name: 'www.zb.com',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://www.zb.com/',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 33,
        numberOfExchanges: 8,
        type: 'coin',
        volume: 36152215,
        marketCap: 161983097,
        price: '0.232795076',
        circulatingSupply: 695818400,
        totalSupply: 2100000000,
        approvedSupply: true,
        firstSeen: 1538092800000,
        change: -0.15,
        rank: 40,
        history: [
          '0.2331560234',
          '0.233804403',
          '0.2332759981',
          '0.2336656398',
          '0.2346302854',
          '0.2362036713',
          '0.2368882048',
          '0.2362280976',
          '0.2358883308',
          '0.235891234',
          '0.2366224688',
          '0.2348923926',
          '0.233590564',
          '0.2329483281',
          '0.2336202136',
          '0.2341489587',
          '0.2345734817',
          '0.2348099871',
          '0.2341931186',
          '0.2342702026',
          '0.2353628952',
          '0.2353191196',
          '0.2346501076',
          '0.2335739021',
          '0.2323605117',
          '0.2343258961',
          '0.232795076',
        ],
        allTimeHigh: { price: '0.4130946000123315', timestamp: 1565568000000 },
        penalty: false,
      },
      {
        id: 5371,
        uuid: 'fZBH2J_bFVMpq',
        slug: 'insightchain-inb',
        symbol: 'INB',
        name: 'Insight Chain',
        description: null,
        color: null,
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/a437VFmgw/insight-chain.svg',
        websiteUrl: null,
        socials: [
          {
            name: 'insightchain',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/insightchain',
            type: 'twitter',
          },
          {
            name: 'insightchain',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/insightchain',
            type: 'telegram',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/insight-chain-210150206429393',
            type: 'facebook',
          },
        ],
        links: [
          {
            name: 'insightchain.io',
            url: 'http://web.archive.org/web/20200411222841/http://www.insightchain.io/',
            type: 'website',
          },
          {
            name: 'insightchain',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/insightchain',
            type: 'twitter',
          },
          {
            name: 'insightchain',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/insightchain',
            type: 'telegram',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/insight-chain-210150206429393',
            type: 'facebook',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 4,
        numberOfExchanges: 3,
        type: 'coin',
        volume: 10400520,
        marketCap: 138243681,
        price: '0.8108476672',
        circulatingSupply: 170492790,
        totalSupply: 10000000000,
        approvedSupply: true,
        firstSeen: 1533772800000,
        change: -0.44,
        rank: 41,
        history: [
          '0.8144288142',
          '0.8158059331',
          '0.8148441018',
          '0.8132675894',
          '0.8123951081',
          '0.8112924268',
          '0.8074503324',
          '0.8080817291',
          '0.8143049778',
          '0.8194727247',
          '0.8223322448',
          '0.8173293423',
          '0.8154617262',
          '0.8138379155',
          '0.8168672448',
          '0.8180693123',
          '0.8203269836',
          '0.8210907278',
          '0.8242806973',
          '0.8261917637',
          '0.8257180005',
          '0.8216732401',
          '0.8177838734',
          '0.8158284251',
          '0.8143450865',
          '0.8124411227',
          '0.8108476672',
        ],
        allTimeHigh: { price: '0.8239571471228077', timestamp: 1586217600000 },
        penalty: false,
      },
      {
        id: 29,
        uuid: 'bOm0xKUuDvCUu',
        slug: 'qtum-qtum',
        symbol: 'QTUM',
        name: 'QTUM',
        description:
          'Qtum is a proof of stake blockchain platform that combines the bitcoin blockchain architecture with multiple virtual machines on top. This lets Qtum benefit from the resiliency, security and infrastructure of bitcoin while enabling decentralized applications and contracts suited for businesses.',
        color: '#2e9ad0',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/vKbtuuXgk/6-Qtum-egg.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://qtum.org/',
        socials: [
          {
            name: 'qtumofficial',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/qtumofficial',
            type: 'twitter',
          },
          {
            name: 'r/qtum',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/qtum/',
            type: 'reddit',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=1729359.0',
            type: 'bitcointalk',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/qtumofficial/',
            type: 'facebook',
          },
          {
            name: 'qtumproject',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/qtumproject/',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'qtum.org',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://qtum.org/',
          },
          {
            name: 'Staking guide',
            url: 'http://web.archive.org/web/20200411222841/https://www.stakingrewards.com/asset/qtum',
            type: 'website',
          },
          {
            name: 'qtumofficial',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/qtumofficial',
            type: 'twitter',
          },
          {
            name: 'r/qtum',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/qtum/',
            type: 'reddit',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=1729359.0',
            type: 'bitcointalk',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/qtumofficial/',
            type: 'facebook',
          },
          {
            name: 'qtumproject',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/qtumproject/',
            type: 'github',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 242,
        numberOfExchanges: 85,
        type: 'coin',
        volume: 172119007,
        marketCap: 136607399,
        price: '1.3350341783',
        circulatingSupply: 102325020,
        totalSupply: 102325020,
        approvedSupply: true,
        firstSeen: 1489708800000,
        change: -0.69,
        rank: 42,
        history: [
          '1.3443542474',
          '1.3421328721',
          '1.3413160643',
          '1.3494743287',
          '1.3603020161',
          '1.3712794099',
          '1.3704033341',
          '1.3765473498',
          '1.3765317814',
          '1.3798586685',
          '1.3660375188',
          '1.3658951016',
          '1.3642795806',
          '1.3686929103',
          '1.3703178564',
          '1.3713792083',
          '1.3689923175',
          '1.357547259',
          '1.3539064386',
          '1.3601441044',
          '1.3466015691',
          '1.3413387202',
          '1.3401050827',
          '1.3314634307',
          '1.319791754',
          '1.3262253135',
          '1.3350341783',
        ],
        allTimeHigh: { price: '86.92131265636925', timestamp: 1515369600000 },
        penalty: false,
      },
      {
        id: 274,
        uuid: '1ZZI6g5k5royD',
        slug: 'trueusd-tusd',
        symbol: 'TUSD',
        name: 'TrueUSD',
        description: null,
        color: '#1f2e5a',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/ZjuIqhhNH/tusd.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://www.trusttoken.com/',
        socials: [
          {
            name: 'Medium',
            url: 'http://web.archive.org/web/20200411222841/https://blog.trusttoken.com/',
            type: 'medium',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/trusttoken/?fref=ts',
            type: 'facebook',
          },
          {
            name: 'trusttoken',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/trusttoken',
            type: 'twitter',
          },
          {
            name: 'Telegram',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/joinchat/hihkmktja1giybrm1j1_vg',
            type: 'telegram',
          },
          {
            name: 'trusttoken',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/trusttoken',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'Medium',
            url: 'http://web.archive.org/web/20200411222841/https://blog.trusttoken.com/',
            type: 'medium',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/trusttoken/?fref=ts',
            type: 'facebook',
          },
          {
            name: 'trusttoken',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/trusttoken',
            type: 'twitter',
          },
          {
            name: 'Telegram',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/joinchat/hihkmktja1giybrm1j1_vg',
            type: 'telegram',
          },
          {
            name: 'trusttoken',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/trusttoken',
            type: 'github',
          },
          {
            name: 'www.trusttoken.com',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://www.trusttoken.com/',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 401,
        numberOfExchanges: 80,
        type: 'coin',
        volume: 687194312,
        marketCap: 135970451,
        price: '0.9964179502',
        circulatingSupply: 136459255.3,
        totalSupply: 136459255.3,
        approvedSupply: true,
        firstSeen: 1520380800000,
        change: -0.11,
        rank: 43,
        history: [
          '0.9975237931',
          '0.9996062178',
          '0.9995863029',
          '0.9983570412',
          '0.9984269519',
          '0.9979705269',
          '0.997873976',
          '0.9974319602',
          '0.9966173402',
          '0.9971387631',
          '0.9979849148',
          '0.997229539',
          '0.9971202165',
          '0.9964959763',
          '0.9969127882',
          '0.996991233',
          '0.9964351786',
          '0.9965972341',
          '0.9974474556',
          '0.997350623',
          '0.997342829',
          '0.9975853508',
          '0.9976078894',
          '0.9985908542',
          '0.9989064445',
          '0.9974375857',
          '0.9964179502',
        ],
        allTimeHigh: { price: '1.0646126324511194', timestamp: 1526515200000 },
        penalty: false,
      },
      {
        id: 28,
        uuid: '1wJlqkxIpJKLN',
        slug: 'decred-dcr',
        symbol: 'DCR',
        name: 'Decred',
        description:
          'Decred is a decentralized blockchain that is completely self-ruling by its stakeholders. The platforms main features are smart contracts, cross-chain cryptocurrency exchange and cross-platform wallets.',
        color: '#3268fb',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/SyJaBU_dZ/dcr.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://www.decred.org/',
        socials: [
          {
            name: 'decredproject',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/decredproject',
            type: 'twitter',
          },
          {
            name: 'r/decred',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/decred',
            type: 'reddit',
          },
          {
            name: 'decred',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/decred',
            type: 'medium',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=1290358.0',
            type: 'bitcointalk',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/ucj2bydapyhpsmjph_m5dnsg',
            type: 'youtube',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/decredcash/',
            type: 'facebook',
          },
          {
            name: 'decred',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/decred',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'www.decred.org',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://www.decred.org/',
          },
          {
            name: 'Staking guide',
            url: 'http://web.archive.org/web/20200411222841/https://www.stakingrewards.com/asset/decred',
            type: 'website',
          },
          {
            name: 'decredproject',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/decredproject',
            type: 'twitter',
          },
          {
            name: 'r/decred',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/decred',
            type: 'reddit',
          },
          {
            name: 'decred',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/decred',
            type: 'medium',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=1290358.0',
            type: 'bitcointalk',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/ucj2bydapyhpsmjph_m5dnsg',
            type: 'youtube',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/decredcash/',
            type: 'facebook',
          },
          {
            name: 'decred',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/decred',
            type: 'github',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 93,
        numberOfExchanges: 35,
        type: 'coin',
        volume: 86079064,
        marketCap: 135380610,
        price: '11.9320645241',
        circulatingSupply: 11345950.17200145,
        totalSupply: 20999999.99800912,
        approvedSupply: true,
        firstSeen: 1441411200000,
        change: -0.96,
        rank: 44,
        history: [
          '12.0480166405',
          '12.023215812',
          '11.9691655298',
          '11.9632119991',
          '12.0634602283',
          '12.0852573342',
          '12.0498166805',
          '12.0515285266',
          '12.0390145461',
          '12.0661664351',
          '12.0323091481',
          '11.9778701404',
          '11.8680664552',
          '11.8404822024',
          '11.8818625056',
          '11.8689346381',
          '11.8492345349',
          '11.8067544366',
          '11.8191868707',
          '11.8440046202',
          '11.8521922083',
          '11.7838464727',
          '11.8012017404',
          '11.8799672193',
          '11.8650090207',
          '11.8971355391',
          '11.9320645241',
        ],
        allTimeHigh: { price: '121.39699352887523', timestamp: 1515888000000 },
        penalty: false,
      },
      {
        id: 63100,
        uuid: 'jad286TjB',
        slug: 'hederahashgraph-hbar',
        symbol: 'HBAR',
        name: 'Hedera HashGraph',
        description:
          'Hedera Hashgraph is a crypto network for conducting value transactions and building decentralized applications. The project claims to combine high security with enormous transactional capacity.',
        color: '#000000',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/dSCnSLilQ/hedera.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://www.hedera.com/',
        socials: [],
        links: [
          {
            name: 'hedera.com',
            url: 'http://web.archive.org/web/20200411222841/https://www.hedera.com/',
            type: 'website',
          },
          {
            name: 'hashgraph',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/hashgraph',
            type: 'twitter',
          },
          {
            name: 'hederahashgraph',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/hederahashgraph',
            type: 'telegram',
          },
          {
            name: 'hashgraph',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/hashgraph',
            type: 'reddit',
          },
          {
            name: 'Discord',
            url: 'http://web.archive.org/web/20200411222841/https://discordapp.com/invite/FFb9YFX',
            type: 'discord',
          },
          {
            name: 'hashgraph',
            url: 'http://web.archive.org/web/20200411222841/https://medium.com/hashgraph',
            type: 'medium',
          },
          {
            name: 'hederahashgraph',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/hederahashgraph',
            type: 'youtube',
          },
          {
            name: 'hashgraph',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/hashgraph',
            type: 'facebook',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 21,
        numberOfExchanges: 10,
        type: 'coin',
        volume: 6913196,
        marketCap: 125999065,
        price: '0.0324451424',
        circulatingSupply: 3883449291,
        totalSupply: 50000000000,
        approvedSupply: true,
        firstSeen: 1568704980000,
        change: -1.73,
        rank: 45,
        history: [
          '0.0330169455',
          '0.0328332152',
          '0.032659003',
          '0.0325768998',
          '0.0329305555',
          '0.0327834009',
          '0.0327365046',
          '0.0329004739',
          '0.0330674835',
          '0.0332003428',
          '0.0327837412',
          '0.0327693457',
          '0.0327466419',
          '0.0326856245',
          '0.0327736081',
          '0.0327937616',
          '0.0327505824',
          '0.0324632331',
          '0.0322741615',
          '0.0324462953',
          '0.0322952959',
          '0.0322899445',
          '0.0323278355',
          '0.0321993323',
          '0.0321625195',
          '0.0324496583',
          '0.0324451424',
        ],
        allTimeHigh: { price: '0.09114170806779999', timestamp: 1568678400000 },
        penalty: false,
      },
      {
        id: 37,
        uuid: 'U70EVFnDc6diV',
        slug: 'icon-icx',
        symbol: 'ICX',
        name: 'ICON',
        description:
          'ICON is one of the largest blockchain networks in the world. ICON has a proven track record and has progressed beyond the initial concept stage. ICON already boasts independent blockchains comprised of reputable institutions in major industries - banks, securities, insurance, hospitals, universities, government and more.',
        color: '#1aaaba',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/By_O0CoXf/ICON.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://www.icon.foundation',
        socials: [
          {
            name: 'helloiconworld',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/helloiconworld',
            type: 'twitter',
          },
          {
            name: 'hello_iconworld',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/hello_iconworld',
            type: 'telegram',
          },
          {
            name: 'r/helloicon',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/helloicon',
            type: 'reddit',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=2115503.0',
            type: 'bitcointalk',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/uc5srwl7cky09cvtudxhtizw',
            type: 'youtube',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/helloicon',
            type: 'facebook',
          },
        ],
        links: [
          {
            name: 'www.icon.foundation',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://www.icon.foundation',
          },
          {
            name: 'Staking guide',
            url: 'http://web.archive.org/web/20200411222841/https://www.stakingrewards.com/asset/icon',
            type: 'website',
          },
          {
            name: 'helloiconworld',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/helloiconworld',
            type: 'twitter',
          },
          {
            name: 'hello_iconworld',
            url: 'http://web.archive.org/web/20200411222841/https://t.me/hello_iconworld',
            type: 'telegram',
          },
          {
            name: 'r/helloicon',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/helloicon',
            type: 'reddit',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=2115503.0',
            type: 'bitcointalk',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/uc5srwl7cky09cvtudxhtizw',
            type: 'youtube',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/helloicon',
            type: 'facebook',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 77,
        numberOfExchanges: 33,
        type: 'coin',
        volume: 14063776,
        marketCap: 119023013,
        price: '0.2272147808',
        circulatingSupply: 523834817,
        totalSupply: 800460000,
        approvedSupply: true,
        firstSeen: 1509148800000,
        change: -1.96,
        rank: 46,
        history: [
          '0.2317554169',
          '0.2309026876',
          '0.2288746452',
          '0.2288068194',
          '0.2334098872',
          '0.2331860202',
          '0.2327562245',
          '0.2350335921',
          '0.2343638061',
          '0.2356374473',
          '0.2330303889',
          '0.2324138511',
          '0.2326773062',
          '0.23179703',
          '0.230595217',
          '0.231383196',
          '0.2308468103',
          '0.2291800033',
          '0.228591057',
          '0.2302797841',
          '0.2284279522',
          '0.2270756722',
          '0.2271745111',
          '0.226189986',
          '0.2254098881',
          '0.2267044528',
          '0.2272147808',
        ],
        allTimeHigh: { price: '11.658555258210923', timestamp: 1515542400000 },
        penalty: false,
      },
      {
        id: 27,
        uuid: '-8WmRrc-b_6dN',
        slug: 'lisk-lsk',
        symbol: 'LSK',
        name: 'Lisk',
        description:
          'Lisk is a blockchain application platform that hosts decentralized applications built in JavaScript. The platform uses sidechains to achieve reliability and scalability on the main chain.',
        color: '#23508e',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/SJTGUIozm/lisk.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://lisk.io/',
        socials: [
          {
            name: 'Medium',
            url: 'http://web.archive.org/web/20200411222841/https://blog.lisk.io/',
            type: 'medium',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/liskhq/',
            type: 'facebook',
          },
          {
            name: 'liskhq',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/liskhq',
            type: 'twitter',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/ucuqpgfg_boq8ja4pj811pwg/featured',
            type: 'youtube',
          },
          {
            name: 'r/lisk',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/lisk/',
            type: 'reddit',
          },
          {
            name: 'liskhq',
            url: 'http://web.archive.org/web/20200411222841/https://www.instagram.com/liskhq/',
            type: 'instagram',
          },
          {
            name: 'lisknews',
            url: 'http://web.archive.org/web/20200411222841/https://telegram.me/lisknews',
            type: 'telegram',
          },
          {
            name: 'Discord',
            url: 'http://web.archive.org/web/20200411222841/https://discord.gg/vspfumk',
            type: 'discord',
          },
          {
            name: 'liskhq',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/liskhq',
            type: 'github',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=1346646',
            type: 'bitcointalk',
          },
        ],
        links: [
          {
            name: 'Medium',
            url: 'http://web.archive.org/web/20200411222841/https://blog.lisk.io/',
            type: 'medium',
          },
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/liskhq/',
            type: 'facebook',
          },
          {
            name: 'liskhq',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/liskhq',
            type: 'twitter',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/ucuqpgfg_boq8ja4pj811pwg/featured',
            type: 'youtube',
          },
          {
            name: 'r/lisk',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/lisk/',
            type: 'reddit',
          },
          {
            name: 'liskhq',
            url: 'http://web.archive.org/web/20200411222841/https://www.instagram.com/liskhq/',
            type: 'instagram',
          },
          {
            name: 'lisknews',
            url: 'http://web.archive.org/web/20200411222841/https://telegram.me/lisknews',
            type: 'telegram',
          },
          {
            name: 'Discord',
            url: 'http://web.archive.org/web/20200411222841/https://discord.gg/vspfumk',
            type: 'discord',
          },
          {
            name: 'liskhq',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/liskhq',
            type: 'github',
          },
          {
            name: 'Bitcoin Talk',
            url: 'http://web.archive.org/web/20200411222841/https://bitcointalk.org/index.php?topic=1346646',
            type: 'bitcointalk',
          },
          {
            name: 'lisk.io',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://lisk.io/',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 91,
        numberOfExchanges: 36,
        type: 'coin',
        volume: 2818529,
        marketCap: 118533783,
        price: '0.9648866487',
        circulatingSupply: 122847365.4562149,
        totalSupply: 139071110,
        approvedSupply: true,
        firstSeen: 1487721600000,
        change: -0.83,
        rank: 47,
        history: [
          '0.9730016564',
          '0.9717171154',
          '0.9684580305',
          '0.9688998741',
          '0.9702008498',
          '0.9706679913',
          '0.970583067',
          '0.9721699973',
          '0.9702531501',
          '0.9718095494',
          '0.9675071053',
          '0.9662789782',
          '0.966217354',
          '0.9660820142',
          '0.9661236181',
          '0.9672795523',
          '0.9662475448',
          '0.9615334478',
          '0.9750274873',
          '0.9799319361',
          '0.9720120957',
          '0.9695681896',
          '0.968027251',
          '0.9673570302',
          '0.966130619',
          '0.9652638006',
          '0.9648866487',
        ],
        allTimeHigh: { price: '35.1304186122936', timestamp: 1515369600000 },
        penalty: false,
      },
      {
        id: 25,
        uuid: 'jWvjEFGAtnhWN',
        slug: '0x-zrx',
        symbol: 'ZRX',
        name: '0x',
        description:
          '0x is a decentralized exchange protocol that enables low friction exchange between ERC20 tokens on the Ethereum blockchain.',
        color: '#595b5b',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/Hy7oqBSFW/zrx.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://0xproject.com/',
        socials: [
          {
            name: 'Medium',
            url: 'http://web.archive.org/web/20200411222841/https://blog.0xproject.com/latest',
            type: 'medium',
          },
          {
            name: '0xproject',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/0xproject',
            type: 'twitter',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/ucfrsppi9wuw9wyta0q1sdna',
            type: 'youtube',
          },
          {
            name: '0xproject',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/0xproject',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'Medium',
            url: 'http://web.archive.org/web/20200411222841/https://blog.0xproject.com/latest',
            type: 'medium',
          },
          {
            name: '0xproject',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/0xproject',
            type: 'twitter',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/ucfrsppi9wuw9wyta0q1sdna',
            type: 'youtube',
          },
          {
            name: '0xproject',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/0xproject',
            type: 'github',
          },
          {
            name: '0xproject.com',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://0xproject.com/',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 249,
        numberOfExchanges: 103,
        type: 'coin',
        volume: 17075344,
        marketCap: 111447731,
        price: '0.1710096219',
        circulatingSupply: 651704448.0422158,
        totalSupply: 1000000000,
        approvedSupply: true,
        firstSeen: 1502409600000,
        change: 1.13,
        rank: 48,
        history: [
          '0.1691032968',
          '0.1685316788',
          '0.1688264552',
          '0.1709958676',
          '0.1704521481',
          '0.1699019227',
          '0.1712181233',
          '0.1719789709',
          '0.1715765539',
          '0.171993411',
          '0.1714644692',
          '0.1710332471',
          '0.1700130357',
          '0.1687223909',
          '0.1690842769',
          '0.169868292',
          '0.1691693613',
          '0.1686278987',
          '0.1690604071',
          '0.1705241354',
          '0.1681237598',
          '0.1684076758',
          '0.1687876528',
          '0.1681693556',
          '0.1665679948',
          '0.1691209619',
          '0.1710096219',
        ],
        allTimeHigh: { price: '5.912189649828956', timestamp: 1506643200000 },
        penalty: false,
      },
      {
        id: 50,
        uuid: '7GNq0jOgaN086',
        slug: 'augur-rep',
        symbol: 'REP',
        name: 'Augur',
        description:
          'Augur is a prediction market that makes use of the Ethereum blockchain. Its ERC20 token REP is used as a value layer for incentivization and payments inside the system.',
        color: '#5f2652',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/H1GlZLd_Z/rep.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://augur.net/',
        socials: [
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/augurproject',
            type: 'facebook',
          },
          {
            name: 'augur',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/augur',
            type: 'twitter',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/ucnqrwiwit8exlegltajjhiq',
            type: 'youtube',
          },
          {
            name: 'r/augur',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/augur/',
            type: 'reddit',
          },
          {
            name: 'augurproject',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/augurproject',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/augurproject',
            type: 'facebook',
          },
          {
            name: 'augur',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/augur',
            type: 'twitter',
          },
          {
            name: 'Youtube',
            url: 'http://web.archive.org/web/20200411222841/https://www.youtube.com/channel/ucnqrwiwit8exlegltajjhiq',
            type: 'youtube',
          },
          {
            name: 'r/augur',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/augur/',
            type: 'reddit',
          },
          {
            name: 'augurproject',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/augurproject',
            type: 'github',
          },
          {
            name: 'augur.net',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://augur.net/',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 136,
        numberOfExchanges: 69,
        type: 'coin',
        volume: 26499937,
        marketCap: 107766717,
        price: '9.7969743111',
        circulatingSupply: 11000000,
        totalSupply: 11000000,
        approvedSupply: true,
        firstSeen: 1475539200000,
        change: -5.07,
        rank: 49,
        history: [
          '10.319801973',
          '10.0092815357',
          '9.834287974',
          '9.8891902332',
          '9.8939428672',
          '9.8504787704',
          '9.7721052852',
          '9.8644247126',
          '9.9098812007',
          '9.9579350738',
          '9.8872241316',
          '9.8689523275',
          '9.8215171374',
          '9.8525500991',
          '9.9478318274',
          '10.070037493',
          '10.050006281',
          '9.9619922115',
          '9.9136218866',
          '9.9422199557',
          '9.8634373421',
          '9.8501013975',
          '9.7976727793',
          '9.7126735648',
          '9.741745394',
          '9.7815579739',
          '9.7969743111',
        ],
        allTimeHigh: { price: '108.1669740659604', timestamp: 1515801600000 },
        penalty: false,
      },
      {
        id: 102,
        uuid: 'hfw0nnnLtSFc7',
        slug: 'gas-gas',
        symbol: 'GAS',
        name: 'Gas',
        description:
          'Gas is a token built on the NEO blockchain used to fuel the execution of smart contracts. All holders of NEO tokens automatically earn gas periodically.',
        color: '#295020',
        iconType: 'vector',
        iconUrl:
          'http://web.archive.org/web/20200411222841/https://cdn.coinranking.com/rJMSO8ddb/neo.svg',
        websiteUrl:
          'http://web.archive.org/web/20200411222841/https://neo.org/',
        socials: [
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/neosmartecon/',
            type: 'facebook',
          },
          {
            name: 'neo_blockchain',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/neo_blockchain',
            type: 'twitter',
          },
          {
            name: 'r/neo',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/neo/',
            type: 'reddit',
          },
          {
            name: 'neo-project',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/neo-project',
            type: 'github',
          },
        ],
        links: [
          {
            name: 'Facebook',
            url: 'http://web.archive.org/web/20200411222841/https://www.facebook.com/neosmartecon/',
            type: 'facebook',
          },
          {
            name: 'neo_blockchain',
            url: 'http://web.archive.org/web/20200411222841/https://twitter.com/neo_blockchain',
            type: 'twitter',
          },
          {
            name: 'r/neo',
            url: 'http://web.archive.org/web/20200411222841/https://www.reddit.com/r/neo/',
            type: 'reddit',
          },
          {
            name: 'neo-project',
            url: 'http://web.archive.org/web/20200411222841/https://github.com/neo-project',
            type: 'github',
          },
          {
            name: 'neo.org',
            type: 'website',
            url: 'http://web.archive.org/web/20200411222841/https://neo.org/',
          },
        ],
        confirmedSupply: true,
        numberOfMarkets: 65,
        numberOfExchanges: 34,
        type: 'coin',
        volume: 5580815,
        marketCap: 107661834,
        price: '1.1184675904',
        circulatingSupply: 96258340.8017974,
        totalSupply: 100000000,
        approvedSupply: true,
        firstSeen: 1503014400000,
        change: -3.16,
        rank: 50,
        history: [
          '1.1549171175',
          '1.148899941',
          '1.1444121147',
          '1.1476761397',
          '1.1479096758',
          '1.1470914946',
          '1.1441112663',
          '1.1469047429',
          '1.1533452654',
          '1.1564391929',
          '1.1470069639',
          '1.1418909133',
          '1.1403859197',
          '1.1372869244',
          '1.1412390398',
          '1.1409210239',
          '1.1380616729',
          '1.1361733288',
          '1.1210416824',
          '1.1237315215',
          '1.1166989545',
          '1.1086938274',
          '1.1129711641',
          '1.1118495234',
          '1.1113779925',
          '1.1145308148',
          '1.1184675904',
        ],
        allTimeHigh: { price: '77.21805687900886', timestamp: 1516060800000 },
        penalty: false,
      },
    ],
  },
};
